
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { submitPackage, sendNotification, fetchRatesApi, getManagers,getFunctionalAdmins} from '../services/api';

// const PackageForm = () => {
//   const [formData, setFormData] = useState({});
//   const [members, setMembers] = useState([]);
//   const [extraCosts, setExtraCosts] = useState([]);
//   const [referenceId, setReferenceId] = useState(null);
//   const [isEditable, setIsEditable] = useState(true);
//   const [sections, setSections] = useState({});
//   const [originalValues, setOriginalValues] = useState({});
//   const [currency, setCurrency] = useState('USD');
//   const [convertedCurrency, setConvertedCurrency] = useState('INR'); // Default secondary
//   const [rates, setRates] = useState({});
// const [symbols] = useState({
//   USD: '$',
//   INR: '₹',
//   EUR: '€',
//   JPY: '¥',
//   CAD: 'CA$',

//   // Existing
//   AUD: 'A$',
//   GBP: '£',
//   SGD: 'S$',
//   AED: 'د.إ',
//   CHF: 'Fr',
//   THB: '฿',
//   MYR: 'RM',
//   ZAR: 'R',
//   NZD: 'NZ$',
//   SAR: '﷼',
//   HKD: 'HK$',

//   // 🔥 NEW ADD
//   IDR: 'Rp',     // Indonesia
//   LKR: 'Rs',     // Sri Lanka
//   VND: '₫',      // Vietnam
//   KHR: '៛',      // Cambodia
//   PHP: '₱'       // Philippines
// });
// const currencyOptions = Object.keys(symbols).sort();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id') || '0', 10);
//   const [showConverted, setShowConverted] = useState(false);
//   const [managers, setManagers] = useState([]);
//   const [selectedManagerId, setSelectedManagerId] = useState('');
// const [isMembersNA, setIsMembersNA] = useState(false);
// const [approverType, setApproverType] = useState('manager');
// const [functionalAdmins, setFunctionalAdmins] = useState([]);
// const [selectedApproverId, setSelectedApproverId] = useState('');
//   // order and money fields
//   const sectionOrder = [
//     'Employee Info',
//     'Agent Info',
//     'Customer Info',
//     'Duration',
//     'Package Costing',
//     'Margin Calculation',
//     'Administrative'
//   ];

//   const moneyFields = [
//     'Flights / Airfare',
//     'Accommodation',
//     'Transfers',
//     'Sightseeing',
//     'Meals',
//     'Visa Fees',
//     'Travel Insurance',
//     'Guide / Driver Tips',
//     'Net Cost',
//     'Selling Price to Customer',
//     'Per Pax Selling Price',
//     'Mark-up',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   const convertedFields = [
//     'Mark-up',
//     'Per Pax Selling Price',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   // fetch rates once and keep updated periodically
//   useEffect(() => {
//     const initial = async () => {
//       await fetchRates();
//     };
//     initial();
//     const id = setInterval(fetchRates, 10 * 60 * 1000);
//     return () => clearInterval(id);
//   }, []);
// useEffect(() => {
//   const fetchApprovers = async () => {
//     try {
//       const managersRes = await getManagers();
//       setManagers(managersRes.data.managers || []);

//       const functionalRes = await getFunctionalAdmins();
//       setFunctionalAdmins(functionalRes.data.managers || []);  // Assuming backend returns 'managers' key; adjust if needed
//     } catch (err) {
//       console.error('Failed to fetch approvers:', err);
//     }
//   };
//   fetchApprovers();
// }, []);
//   const fetchRates = async () => {
//     try {
//       if (fetchRatesApi) {
//         const r = await fetchRatesApi();
//         setRates(r || {});
//         return;
//       }
//       const res = await fetch(`https://open.er-api.com/v6/latest/USD`);
//       const data = await res.json();
//       if (data.result === "success") setRates(data.rates || {});
//     } catch (err) {
//       console.error("Failed to fetch rates:", err);
//     }
//   };

//   useEffect(() => {
//     const allFields = [
//       { id: 1, section: 'Employee Info', field_name: 'Employee Name', field_type: 'text', is_required: true },
//       { id: 2, section: 'Employee Info', field_name: 'Employee Code', field_type: 'text', is_required: true },
//       { id: 3, section: 'Agent Info', field_name: 'Agent Name', field_type: 'text', is_required: true },
//       { id: 4, section: 'Agent Info', field_name: 'Agency Name', field_type: 'text', is_required: true },
//       { id: 5, section: 'Agent Info', field_name: 'Agent Number', field_type: 'text', is_required: true },
//       { id: 6, section: 'Agent Info', field_name: 'Agent Email', field_type: 'email', is_required: true },
//       { id: 8, section: 'Customer Info', field_name: 'Customer Name', field_type: 'text', is_required: true },
//       { id: 13, section: 'Customer Info', field_name: 'No. of Pax', field_type: 'number', is_required: true },
//       { id: 9, section: 'Customer Info', field_name: 'Customer Email', field_type: 'email', is_required: false },
//       { id: 10, section: 'Customer Info', field_name: 'Customer Mobile', field_type: 'text', is_required: false },
//       { id: 11, section: 'Customer Info', field_name: 'Start Date', field_type: 'date', is_required: true },
//       { id: 12, section: 'Customer Info', field_name: 'End Date', field_type: 'date', is_required: true },
//       { id: 14, section: 'Duration', field_name: 'Days', field_type: 'number', is_required: true },
//       { id: 15, section: 'Duration', field_name: 'Nights', field_type: 'number', is_required: true },

//       // costing
//       { id: 16, section: 'Package Costing', field_name: 'Flights / Airfare', field_type: 'number' },
//       { id: 17, section: 'Package Costing', field_name: 'Accommodation', field_type: 'number' },
//       { id: 18, section: 'Package Costing', field_name: 'Transfers', field_type: 'number' },
//       { id: 19, section: 'Package Costing', field_name: 'Sightseeing', field_type: 'number' },
//       { id: 20, section: 'Package Costing', field_name: 'Meals', field_type: 'number' },
//       { id: 21, section: 'Package Costing', field_name: 'Visa Fees', field_type: 'number' },
//       { id: 22, section: 'Package Costing', field_name: 'Travel Insurance', field_type: 'number' },
//       { id: 23, section: 'Package Costing', field_name: 'Guide / Driver Tips', field_type: 'number' },
//       { id: 24, section: 'Package Costing', field_name: 'Net Cost', field_type: 'number' },

//       // margin
//       { id: 25, section: 'Margin Calculation', field_name: 'Mark-up %', field_type: 'number' },
//       { id: 26, section: 'Margin Calculation', field_name: 'Mark-up', field_type: 'number' },
//       { id: 27, section: 'Margin Calculation', field_name: 'Selling Price to Customer', field_type: 'number' },
//       { id: 28, section: 'Margin Calculation', field_name: 'Per Pax Selling Price', field_type: 'number' },
//       { id: 29, section: 'Margin Calculation', field_name: 'Less: Agent Commission %', field_type: 'number' },
//       { id: 30, section: 'Margin Calculation', field_name: 'Less: Agent Commission', field_type: 'number' },
//       { id: 31, section: 'Margin Calculation', field_name: 'Less: Transaction Charges %', field_type: 'number' },
//       { id: 32, section: 'Margin Calculation', field_name: 'Less: Transaction Charges', field_type: 'number' },
//       { id: 33, section: 'Margin Calculation', field_name: 'Gross Margin %', field_type: 'number' },
//       { id: 34, section: 'Margin Calculation', field_name: 'Gross Margin', field_type: 'number' },

//       ...(role !== 'employee' ? [] : []),
//     ];

//     const grouped = allFields.reduce((acc, field) => {
//       if (!acc[field.section]) acc[field.section] = [];
//       acc[field.section].push(field);
//       return acc;
//     }, {});

//     setFormData(allFields.reduce((acc, f) => ({ ...acc, [f.field_name]: f.field_type === 'checkbox' ? false : '' }), {}));
//     setSections(grouped);

//     if (location.state?.package) {
//       const pkg = location.state.package;
//       setReferenceId(pkg.reference_id);
//       setFormData(prev => ({ ...prev, ...(pkg.data || {}) }));
//       setMembers(pkg.data?.['Travelling Members'] || []);
//       setExtraCosts(pkg.data?.['Extra Costs'] || []);
//       setCurrency(pkg.currency || 'USD');
//       setConvertedCurrency(pkg.converted_currency || 'INR');
//       setOriginalValues(
//         moneyFields.reduce((acc, f) => ({ ...acc, [f]: parseFloat(pkg.data?.[f] || 0) }), {})
//       );

//       if (pkg.status === 'approved') {
//         setIsEditable(false);
//       }
//     }
//   }, [location.state]);

//   const isCalculated = (fieldName) =>
//     ['Net Cost', 'Selling Price to Customer', 'Per Pax Selling Price', 'Gross Margin', 'Gross Margin %', 'Mark-up', 'Less: Agent Commission', 'Days', 'Nights'].includes(fieldName);

//   const todayISO = new Date().toISOString().split('T')[0];

//   const handleChange = (e) => {
//     if (!isEditable) return;
//     const { name, value, type, checked } = e.target;
//     const val = type === 'checkbox' ? checked : value;
//     const newData = { ...formData, [name]: val };

//     if (name.endsWith('_NA')) {
//       const fieldName = name.replace('_NA', '');
//       if (val) {
//         newData[fieldName] = 'N/A';
//         setOriginalValues(prev => ({ ...prev, [fieldName]: 0 }));
//       } else {
//         newData[fieldName] = '';
//       }
//     }

//     if (moneyFields.includes(name) || name === 'Less: Transaction Charges %') {
//       setOriginalValues(prev => ({ ...prev, [name]: parseFloat(val) || 0 }));
//     }

//     setFormData(newData);
//     calculate(newData);
//   };

//   const calculate = (data) => {
//     // Days & Nights
//     if (data['Start Date'] && data['End Date']) {
//       const startDate = new Date(data['Start Date']);
//       const endDate = new Date(data['End Date']);
//       startDate.setHours(0, 0, 0, 0); endDate.setHours(0, 0, 0, 0);
//       if (endDate >= startDate) {
//         const days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
//         data['Days'] = days.toString();
//         data['Nights'] = (days - 1).toString();
//       } else {
//         data['Days'] = ''; data['Nights'] = '';
//       }
//     } else {
//       data['Days'] = ''; data['Nights'] = '';
//     }

//     // Net Cost
//     let totalNet = 0;
//     const costingFields = ['Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals', 'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips'];
//     costingFields.forEach(f => {
//       totalNet += (data[f] === 'N/A' ? 0 : parseFloat(data[f]) || 0);
//     });
//     totalNet += extraCosts.reduce((acc, c) => acc + (parseFloat(c.value) || 0), 0);
//     data['Net Cost'] = totalNet.toFixed(2);

//     const noOfPax = parseFloat(data['No. of Pax']) || 1;

//     const grossTargetPercent = parseFloat(data['Gross % Target']) || 0;
//     let markupPercent = parseFloat(data['Mark-up %']) || 0;

//     if (grossTargetPercent > 0 && !data['Mark-up %']) {
//       const agentPct = parseFloat(data['Less: Agent Commission %']) || 0;
//       const transPct = parseFloat(data['Less: Transaction Charges %']) || 0;
//       const deductPct = agentPct + transPct;

//       if (grossTargetPercent < 100 - deductPct) {
//         const targetGrossRatio = grossTargetPercent / 100;
//         const remaining = 1 - deductPct / 100;
//         const requiredSellingRatio = targetGrossRatio / remaining;
//         markupPercent = (requiredSellingRatio * 100) / (1 - requiredSellingRatio);
//         if (markupPercent >= 0) {
//           data['Mark-up %'] = markupPercent.toFixed(4);
//         }
//       }
//     }

//     const markup = totalNet * (markupPercent / 100);
//     data['Mark-up'] = markup.toFixed(2);

//     const sellingPrice = totalNet + markup;
//     data['Selling Price to Customer'] = sellingPrice.toFixed(2);
//     data['Per Pax Selling Price'] = (sellingPrice / noOfPax).toFixed(2);

//     const agentCommission = sellingPrice * (parseFloat(data['Less: Agent Commission %']) || 0) / 100;
//     data['Less: Agent Commission'] = agentCommission.toFixed(2);

//     const transactionCharges = sellingPrice * (parseFloat(data['Less: Transaction Charges %']) || 0) / 100;
//     data['Less: Transaction Charges'] = transactionCharges.toFixed(2);

//     const grossMargin = sellingPrice - totalNet - agentCommission - transactionCharges;
//     data['Gross Margin'] = grossMargin.toFixed(2);
//     data['Gross Margin %'] = sellingPrice > 0 ? ((grossMargin / sellingPrice) * 100).toFixed(2) : '0.00';

//     setFormData({ ...data });
//   };

//   const getConversionRate = (fromCurrency = currency, toCurrency = convertedCurrency, currentRates = rates) => {
//     try {
//       if (!currentRates || !currentRates[fromCurrency] || !currentRates[toCurrency] || fromCurrency === toCurrency) return 1;
//       // API rates relative to USD: rate[target] / rate[from] = conversion factor
//       return currentRates[toCurrency] / currentRates[fromCurrency];
//     } catch (err) {
//       console.error('Conversion rate error:', err);
//       return 1;
//     }
//   };

//   const convertValue = (value, fromCurrency = currency, toCurrency = convertedCurrency) => {
//     const v = parseFloat(value) || 0;
//     const r = getConversionRate(fromCurrency, toCurrency, rates);
//     return (v * r).toFixed(2);
//   };

//   const handleCurrencyChange = (e, isMain = true) => {
//     const newCurrency = e.target.value;
//     if (isMain) {
//       setCurrency(newCurrency);
//     } else {
//       setConvertedCurrency(newCurrency);
//     }
//     // No need to recalculate - numbers don't change, only display currency changes
//     // convertValue() reads currency/convertedCurrency from state which updates on next render
//   };

//   const addMember = () => setMembers([...members, '']);
//   const updateMember = (i, v) => {
//     const newM = [...members]; newM[i] = v; setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };
//   const removeMember = (i) => {
//     const newM = members.filter((_, idx) => idx !== i);
//     setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };

//   const addCostField = () => setExtraCosts([...extraCosts, { label: '', value: '' }]);
//   const updateCostField = (i, k, v) => {
//     const newCosts = [...extraCosts];
//     newCosts[i][k] = v;
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };
//   const removeCostField = (i) => {
//     const newCosts = extraCosts.filter((_, idx) => idx !== i);
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };

// const handleSubmit = async () => {
//   if (!selectedApproverId) {
//     alert(`Please select a ${approverType === 'manager' ? 'Manager' : 'Functional Admin'} to assign.`);
//     return;
//   }

//   await fetchRates();
//   const rate = getConversionRate();

//   if (convertedCurrency && convertedCurrency !== currency && rate <= 0) {
//     alert(
//       `No exchange rate available for ${currency} → ${convertedCurrency}. ` +
//       `Please wait a few seconds and try again.`
//     );
//     return;
//   }

//   const dataToSubmit = {
//     ...formData,
//     'Travelling Members': members.filter(m => m?.trim()),
//     'Extra Costs': extraCosts.filter(c => c?.label?.trim() && c?.value),
//   };

//   try {
//     const response = await submitPackage(user_id, {
//       data: dataToSubmit,
//       currency,
//       convertedCurrency: convertedCurrency || null,
//       exchangeRate: rate,
//       assignedApproverId: parseInt(selectedApproverId, 10),
//       assigned_approver_id: parseInt(selectedApproverId, 10),
//       approverRole: approverType,
//       approver_role: approverType,
//     });

//     if (response.data.success) {
//       alert('Package submitted successfully for approval!');
//       navigate('/dashboard/view-packages');
//     } else {
//       alert('Submission failed: ' + (response.data.error || 'Unknown error'));
//     }
//   } catch (error) {
//     console.error('Package submission error:', error);
//     alert(
//       'Failed to submit package.\n' +
//       (error.response?.data?.error || error.message || 'Please check your connection and try again.')
//     );
//   }
// };
//   // Dynamic left padding based on symbol character length to prevent overlap
// const getSymbolPadding = (sym) => {
//   if (!sym) return '28px';

//   const len = sym.length;

//   if (len === 1) return '28px';     // $, ₹, ₱, ฿
//   if (len === 2) return '34px';     // Fr, RM, Rp
//   if (len === 3) return '40px';     // A$, NZ$, HK$
//   return '48px';                    // د.إ etc
// };

//   const toggleNA = (field) => {
//     if (!isEditable) return;
//     const isNA = formData[`${field}_NA`];
//     const newData = { ...formData };
//     newData[`${field}_NA`] = !isNA;
//     newData[field] = !isNA ? 'N/A' : '';
//     setFormData(newData);
//     calculate(newData);
//   };

//   return (
//     <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">{referenceId ? `Package ${referenceId}` : 'Create Package'}</h2>

//       {/* Top Controls */}
//       <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">

//         {/* Package Name */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Package Name</label>
//           <input
//             type="text"
//             name="Package Name"
//             value={formData["Package Name"] || ""}
//             onChange={handleChange}
//             placeholder="Enter Package Name"
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             required
//             readOnly={!isEditable}
//           />
//         </div>

//         {/* Main Currency */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Main Currency</label>
//  <select
//   value={currency}
//   onChange={(e) => handleCurrencyChange(e, true)}
//   className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//   disabled={!isEditable}
// >
//   {currencyOptions.map((c) => (
//     <option key={c} value={c}>
//       {c} ({symbols[c]})
//     </option>
//   ))}
// </select>
//         </div>

//         {/* Approver Type */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Approver Type</label>
//           <select
//             value={approverType}
//             onChange={(e) => { setApproverType(e.target.value); setSelectedApproverId(''); }}
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             disabled={!isEditable}
//           >
//             <option value="manager">Manager</option>
//             <option value="functional_admin">Functional Admin</option>
//           </select>
//         </div>

//         {/* Select Approver */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Select {approverType === 'manager' ? 'Manager' : 'Functional Admin'}
//           </label>
//           <select
//             value={selectedApproverId}
//             onChange={(e) => setSelectedApproverId(e.target.value)}
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             disabled={!isEditable}
//           >
//             <option value="">Select...</option>
//             {(approverType === "manager" ? managers : functionalAdmins).map((approver) => (
//               <option key={approver.id} value={approver.id}>
//                 {approver.name || approver.username} ({approver.email})
//               </option>
//             ))}
//           </select>
//         </div>

//       </div>

//       <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-100">
//         {sectionOrder.map(section => (
//           <div key={section} className="mb-8">
//             <h3 className="text-lg sm:text-xl font-semibold mb-4 pb-2 border-b border-gray-200">{section}</h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//               {sections[section]?.map(field => (
//                 <div key={field.id} className="flex flex-col">
//                   <label className="block text-gray-700 text-sm font-medium mb-1.5">
//                     {field.field_name}{field.is_required ? ' *' : ''}
//                   </label>

//                   {field.field_type === 'date' ? (
//                     <input
//                       type="date"
//                       name={field.field_name}
//                       value={formData[field.field_name] || ''}
//                       onChange={handleChange}
//                       readOnly={!isEditable}
//                       min={todayISO}
//                       className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//                       required={field.is_required}
//                     />
//                   ) : field.field_type === 'checkbox' ? (
//                     <div className="flex items-center h-10">
//                       <input
//                         type="checkbox"
//                         name={field.field_name}
//                         checked={!!formData[field.field_name]}
//                         onChange={handleChange}
//                         disabled={!isEditable}
//                         className="h-5 w-5 rounded border-gray-300 text-indigo-600"
//                       />
//                     </div>
//                   ) : (
//                     <div className="relative flex items-center">
//                       {moneyFields.includes(field.field_name) && (
//                         <span className="absolute left-3 text-gray-500 text-sm font-medium pointer-events-none select-none">
//                           {symbols[currency]}
//                         </span>
//                       )}
//                       <input
//                         type={field.field_type}
//                         name={field.field_name}
//                         value={formData[field.field_name] || ''}
//                         onChange={handleChange}
//                         readOnly={isCalculated(field.field_name) || !isEditable}
//                         style={moneyFields.includes(field.field_name) ? { paddingLeft: getSymbolPadding(symbols[currency]) } : {}}
//                         className={`w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
//                           ${field.field_name.includes('Gross Margin') ? 'font-bold bg-green-50' : ''}
//                           ${isCalculated(field.field_name) ? 'bg-gray-50 text-gray-600' : ''}
//                         `}
//                         required={field.is_required}
//                       />
//                     </div>
//                   )}

//                   {section === 'Package Costing' && field.field_type === 'number' && (
//                     <label className="inline-flex items-center gap-2 mt-2 cursor-pointer select-none">
//                       <input
//                         type="checkbox"
//                         name={`${field.field_name}_NA`}
//                         checked={!!formData[`${field.field_name}_NA`]}
//                         onChange={() => toggleNA(field.field_name)}
//                         disabled={!isEditable}
//                         className="h-4 w-4 rounded border-gray-300 text-indigo-600"
//                       />
//                       <span className="text-xs text-gray-500">Mark as N/A</span>
//                     </label>
//                   )}
//                 </div>
//               ))}

// {section === 'Margin Calculation' && showConverted && (
//   <div className="col-span-1 sm:col-span-2 mt-4 border-t border-gray-200 pt-4">
//     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//       <div className="sm:col-span-2">
//         <label className="block text-sm font-medium text-gray-700 mb-1.5">Converted Currency:</label>
//      <select
//   value={convertedCurrency}
//   onChange={(e) => handleCurrencyChange(e, false)}
//   className="p-2.5 border border-gray-300 rounded-md text-sm w-full sm:w-48"
//   disabled={!isEditable}
// >
//   {currencyOptions.map((c) => (
//     <option key={c} value={c}>
//       {c} ({symbols[c]})
//     </option>
//   ))}
// </select>
//       </div>

//       {convertedFields.map(f => (
//         <div key={f}>
//           <label className="block text-xs text-gray-500 mb-1.5">{f} ({symbols[convertedCurrency]})</label>
//           <div className="relative flex items-center">
//             <span className="absolute left-3 text-gray-500 text-sm pointer-events-none">{symbols[convertedCurrency]}</span>
//             <input
//               type="text"
//               value={convertValue(formData[f])}
//               readOnly
//               style={{ paddingLeft: getSymbolPadding(symbols[convertedCurrency]) }}
//               className="w-full p-2.5 border border-gray-200 rounded-md text-sm bg-gray-50 text-gray-600"
//             />
//           </div>
//         </div>
//       ))}

//       <div className="sm:col-span-2 text-xs text-gray-400 bg-gray-50 rounded-md p-3">
//         <p>Live rates used for conversion.</p>
//         <p className="mt-0.5">Rate: 1 {currency} = {(getConversionRate()).toFixed(4)} {convertedCurrency}</p>
//       </div>

//     </div>
//   </div>
// )}

//         {section === 'Customer Info' && (
//   <div className="col-span-1 sm:col-span-2 mt-2">
//     <div className="flex items-center justify-between mb-3">
//       <h4 className="text-sm font-medium text-gray-700">Travelling Members <span className="text-gray-400 font-normal">(Optional)</span></h4>
//       <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
//         <input
//           type="checkbox"
//           checked={isMembersNA}
//           onChange={() => setIsMembersNA(!isMembersNA)}
//           disabled={!isEditable}
//           className="h-4 w-4 rounded border-gray-300"
//         />
//         <span className="text-gray-600">N/A</span>
//       </label>
//     </div>

//     {!isMembersNA && (
//       <>
//         {members.map((m, i) => (
//           <div key={i} className="flex gap-2 mb-2">
//             <input
//               type="text"
//               value={m}
//               onChange={(e) => updateMember(i, e.target.value)}
//               className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
//               readOnly={!isEditable}
//               placeholder={`Member ${i + 1}`}
//             />
//             <button
//               type="button"
//               onClick={() => removeMember(i)}
//               className="text-red-500 text-sm font-medium px-2 hover:text-red-700"
//               disabled={!isEditable}
//             >
//               Remove
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           onClick={addMember}
//           className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
//           disabled={!isEditable}
//         >
//           + Add Member
//         </button>
//       </>
//     )}
//     {isMembersNA && (
//       <p className="text-gray-400 text-sm italic">Not Applicable</p>
//     )}
//   </div>
// )}

//               {section === 'Package Costing' && (
//                 <div className="col-span-1 sm:col-span-2 mt-2">
//                   <h4 className="text-sm font-medium text-gray-700 mb-2">Extra Costs</h4>
//                   {extraCosts.map((c, i) => (
//                     <div key={i} className="flex flex-col sm:flex-row gap-2 mb-3">
//                       <input
//                         type="text"
//                         value={c.label}
//                         onChange={(e) => updateCostField(i, 'label', e.target.value)}
//                         placeholder="Cost Label"
//                         className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
//                         readOnly={!isEditable}
//                       />
//                       <div className="flex items-center gap-2">
//                         <div className="relative flex-1 sm:flex-none">
//                           <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">{symbols[currency]}</span>
//                           <input
//                             type="number"
//                             value={c.value}
//                             onChange={(e) => updateCostField(i, 'value', e.target.value)}
//                             placeholder="Amount"
//                             style={{ paddingLeft: getSymbolPadding(symbols[currency]) }}
//                             className="w-full sm:w-32 p-2.5 border border-gray-300 rounded-md text-sm"
//                             readOnly={!isEditable}
//                           />
//                         </div>
//                         <button
//                           type="button"
//                           onClick={() => removeCostField(i)}
//                           className="text-red-500 text-sm font-medium whitespace-nowrap hover:text-red-700"
//                           disabled={!isEditable}
//                         >
//                           Remove
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                   <button
//                     type="button"
//                     onClick={addCostField}
//                     className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
//                     disabled={!isEditable}
//                   >
//                     + Add Cost Field
//                   </button>
//                 </div>
//               )}

//               {section === 'Administrative' && (
//                 <div className="col-span-1 sm:col-span-2 mt-2">
//                   <div className="flex flex-wrap gap-3 items-center">
//                     <button
//                       type="button"
//                       onClick={handleSubmit}
//                       className={`bg-green-500 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-green-600 transition-colors ${!isEditable ? 'opacity-60 cursor-not-allowed' : ''}`}
//                       disabled={!isEditable}
//                     >
//                       Submit for Approval
//                     </button>

//                     {role !== 'employee' && location.state?.package?.status === 'approved' && (
//                       <button
//                         type="button"
//                         onClick={() => {
//                           const pkg = location.state.package;
//                           const newData = { ...pkg.data };
//                           delete newData['Invoice Reference'];
//                           setReferenceId(null);
//                           setFormData(newData);
//                           setMembers(pkg.data?.['Travelling Members'] || []);
//                           setExtraCosts(pkg.data?.['Extra Costs'] || []);
//                           setIsEditable(true);
//                           alert('New package created from approved one.');
//                         }}
//                         className="bg-indigo-600 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
//                       >
//                         Create New Package
//                       </button>
//                     )}
//                   </div>

//                   {!isEditable && (
//                     <div className="text-sm text-red-600 mt-2">Package is approved and frozen.</div>
//                   )}

//                   <div className="mt-4 text-xs text-gray-500 bg-gray-50 rounded-md p-3">
//                     <div>Rate: 1 {currency} = {getConversionRate(currency, convertedCurrency, rates).toFixed(4)} {convertedCurrency}</div>
//                     <div className="mt-0.5 text-gray-400">{rates[currency] ? 'Live rates active' : 'Offline — using last known rates'}</div>
//                     <div className="mt-1">Source: <a href="https://www.xe.com" target="_blank" rel="noreferrer" className="underline text-blue-600">XE.com</a></div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
// <div className="flex items-center gap-3 mt-6 mb-2 p-3 bg-indigo-50 rounded-lg">
//   <span className="font-medium text-gray-700 text-sm">Show Converted Currency</span>
//   <div
//     onClick={() => setShowConverted(prev => !prev)}
//     style={{
//       width: 44, height: 24, borderRadius: 12, cursor: 'pointer', position: 'relative',
//       backgroundColor: showConverted ? '#22c55e' : '#d1d5db',
//       transition: 'background-color 0.3s'
//     }}
//   >
//     <div style={{
//       position: 'absolute', top: 3, left: showConverted ? 23 : 3,
//       width: 18, height: 18, borderRadius: '50%', backgroundColor: '#fff',
//       boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
//       transition: 'left 0.3s'
//     }} />
//   </div>
//   <span className="text-xs text-gray-500">{showConverted ? 'ON' : 'OFF'}</span>
// </div>

//       </div>
//     </div>
//   );
// };

// export default PackageForm;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { submitPackage, sendNotification, fetchRatesApi, getManagers,getFunctionalAdmins} from '../services/api';

// const PackageForm = () => {
//   const [formData, setFormData] = useState({});
//   const [members, setMembers] = useState([]);
//   const [extraCosts, setExtraCosts] = useState([]);
//   const [referenceId, setReferenceId] = useState(null);
//   const [isEditable, setIsEditable] = useState(true);
//   const [sections, setSections] = useState({});
//   const [originalValues, setOriginalValues] = useState({});
//   const [currency, setCurrency] = useState('USD');
//   const [convertedCurrency, setConvertedCurrency] = useState('INR'); // Default secondary
//   const [rates, setRates] = useState({});
//   const [symbols] = useState({ USD: '$', INR: '₹', EUR: '€', JPY: '¥', CAD: 'CA$' });
//   const navigate = useNavigate();
//   const location = useLocation();
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id') || '0', 10);
//   const [showConverted, setShowConverted] = useState(false);
//   const [managers, setManagers] = useState([]);
//   const [selectedManagerId, setSelectedManagerId] = useState('');
// const [isMembersNA, setIsMembersNA] = useState(false);
// const [approverType, setApproverType] = useState('manager');
// const [functionalAdmins, setFunctionalAdmins] = useState([]);
// const [selectedApproverId, setSelectedApproverId] = useState('');
//   // order and money fields
//   const sectionOrder = [
//     'Employee Info',
//     'Agent Info',
//     'Customer Info',
//     'Duration',
//     'Package Costing',
//     'Margin Calculation',
//     'Administrative'
//   ];

//   const moneyFields = [
//     'Flights / Airfare',
//     'Accommodation',
//     'Transfers',
//     'Sightseeing',
//     'Meals',
//     'Visa Fees',
//     'Travel Insurance',
//     'Guide / Driver Tips',
//     'Net Cost',
//     'Selling Price to Customer',
//     'Per Pax Selling Price',
//     'Mark-up',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   const convertedFields = [
//     'Mark-up',
//     'Per Pax Selling Price',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   // fetch rates once and keep updated periodically
//   useEffect(() => {
//     const initial = async () => {
//       await fetchRates();
//     };
//     initial();
//     const id = setInterval(fetchRates, 10 * 60 * 1000);
//     return () => clearInterval(id);
//   }, []);
// useEffect(() => {
//   const fetchApprovers = async () => {
//     try {
//       const managersRes = await getManagers();
//       setManagers(managersRes.data.managers || []);

//       const functionalRes = await getFunctionalAdmins();
//       setFunctionalAdmins(functionalRes.data.managers || []);  // Assuming backend returns 'managers' key; adjust if needed
//     } catch (err) {
//       console.error('Failed to fetch approvers:', err);
//     }
//   };
//   fetchApprovers();
// }, []);
//   const fetchRates = async () => {
//     try {
//       if (fetchRatesApi) {
//         const r = await fetchRatesApi();
//         setRates(r || {});
//         return;
//       }
//       const res = await fetch(`https://open.er-api.com/v6/latest/USD`);
//       const data = await res.json();
//       if (data.rates) setRates(data.rates || {});
//     } catch (err) {
//       console.error("Failed to fetch rates:", err);
//     }
//   };

//   useEffect(() => {
//     const allFields = [
//       { id: 1, section: 'Employee Info', field_name: 'Employee Name', field_type: 'text', is_required: true },
//       { id: 2, section: 'Employee Info', field_name: 'Employee Code', field_type: 'text', is_required: true },
//       { id: 3, section: 'Agent Info', field_name: 'Agent Name', field_type: 'text', is_required: true },
//       { id: 4, section: 'Agent Info', field_name: 'Agency Name', field_type: 'text', is_required: true },
//       { id: 5, section: 'Agent Info', field_name: 'Agent Number', field_type: 'text', is_required: true },
//       { id: 6, section: 'Agent Info', field_name: 'Agent Email', field_type: 'email', is_required: true },
//       { id: 8, section: 'Customer Info', field_name: 'Customer Name', field_type: 'text', is_required: true },
//       { id: 13, section: 'Customer Info', field_name: 'No. of Pax', field_type: 'number', is_required: true },
//       { id: 9, section: 'Customer Info', field_name: 'Customer Email', field_type: 'email', is_required: false },
//       { id: 10, section: 'Customer Info', field_name: 'Customer Mobile', field_type: 'text', is_required: false },
//       { id: 11, section: 'Customer Info', field_name: 'Start Date', field_type: 'date', is_required: true },
//       { id: 12, section: 'Customer Info', field_name: 'End Date', field_type: 'date', is_required: true },
//       { id: 14, section: 'Duration', field_name: 'Days', field_type: 'number', is_required: true },
//       { id: 15, section: 'Duration', field_name: 'Nights', field_type: 'number', is_required: true },

//       // costing
//       { id: 16, section: 'Package Costing', field_name: 'Flights / Airfare', field_type: 'number' },
//       { id: 17, section: 'Package Costing', field_name: 'Accommodation', field_type: 'number' },
//       { id: 18, section: 'Package Costing', field_name: 'Transfers', field_type: 'number' },
//       { id: 19, section: 'Package Costing', field_name: 'Sightseeing', field_type: 'number' },
//       { id: 20, section: 'Package Costing', field_name: 'Meals', field_type: 'number' },
//       { id: 21, section: 'Package Costing', field_name: 'Visa Fees', field_type: 'number' },
//       { id: 22, section: 'Package Costing', field_name: 'Travel Insurance', field_type: 'number' },
//       { id: 23, section: 'Package Costing', field_name: 'Guide / Driver Tips', field_type: 'number' },
//       { id: 24, section: 'Package Costing', field_name: 'Net Cost', field_type: 'number' },

//       // margin
//       { id: 25, section: 'Margin Calculation', field_name: 'Mark-up %', field_type: 'number' },
//       { id: 26, section: 'Margin Calculation', field_name: 'Mark-up', field_type: 'number' },
//       { id: 27, section: 'Margin Calculation', field_name: 'Selling Price to Customer', field_type: 'number' },
//       { id: 28, section: 'Margin Calculation', field_name: 'Per Pax Selling Price', field_type: 'number' },
//       { id: 29, section: 'Margin Calculation', field_name: 'Less: Agent Commission %', field_type: 'number' },
//       { id: 30, section: 'Margin Calculation', field_name: 'Less: Agent Commission', field_type: 'number' },
//       { id: 31, section: 'Margin Calculation', field_name: 'Less: Transaction Charges %', field_type: 'number' },
//       { id: 32, section: 'Margin Calculation', field_name: 'Less: Transaction Charges', field_type: 'number' },
//       { id: 33, section: 'Margin Calculation', field_name: 'Gross Margin %', field_type: 'number' },
//       { id: 34, section: 'Margin Calculation', field_name: 'Gross Margin', field_type: 'number' },
//       // { id: 35, section: 'Margin Calculation', field_name: 'Gross % Target', field_type: 'number' }, // NEW

//       ...(role !== 'employee' ? [] : []),
//     ];

//     const grouped = allFields.reduce((acc, field) => {
//       if (!acc[field.section]) acc[field.section] = [];
//       acc[field.section].push(field);
//       return acc;
//     }, {});

//     setFormData(allFields.reduce((acc, f) => ({ ...acc, [f.field_name]: f.field_type === 'checkbox' ? false : '' }), {}));
//     setSections(grouped);

//     if (location.state?.package) {
//       const pkg = location.state.package;
//       setReferenceId(pkg.reference_id);
//       setFormData(prev => ({ ...prev, ...(pkg.data || {}) }));
//       setMembers(pkg.data?.['Travelling Members'] || []);
//       setExtraCosts(pkg.data?.['Extra Costs'] || []);
//       setCurrency(pkg.currency || 'USD');
//       setConvertedCurrency(pkg.converted_currency || 'INR');
//       setOriginalValues(
//         moneyFields.reduce((acc, f) => ({ ...acc, [f]: parseFloat(pkg.data?.[f] || 0) }), {})
//       );

//       if (pkg.status === 'approved') {
//         setIsEditable(false);
//       }
//     }
//   }, [location.state]);

//   const isCalculated = (fieldName) =>
//     ['Net Cost', 'Selling Price to Customer', 'Per Pax Selling Price', 'Gross Margin', 'Gross Margin %', 'Mark-up', 'Less: Agent Commission', 'Days', 'Nights'].includes(fieldName);

//   const todayISO = new Date().toISOString().split('T')[0];

//   const handleChange = (e) => {
//     if (!isEditable) return;
//     const { name, value, type, checked } = e.target;
//     const val = type === 'checkbox' ? checked : value;
//     const newData = { ...formData, [name]: val };

//     if (name.endsWith('_NA')) {
//       const fieldName = name.replace('_NA', '');
//       if (val) {
//         newData[fieldName] = 'N/A';
//         setOriginalValues(prev => ({ ...prev, [fieldName]: 0 }));
//       } else {
//         newData[fieldName] = '';
//       }
//     }

//     if (moneyFields.includes(name) || name === 'Less: Transaction Charges %') {
//       setOriginalValues(prev => ({ ...prev, [name]: parseFloat(val) || 0 }));
//     }

//     setFormData(newData);
//     calculate(newData);
//   };

//   const calculate = (data) => {
//     // Days & Nights
//     if (data['Start Date'] && data['End Date']) {
//       const startDate = new Date(data['Start Date']);
//       const endDate = new Date(data['End Date']);
//       startDate.setHours(0, 0, 0, 0); endDate.setHours(0, 0, 0, 0);
//       if (endDate >= startDate) {
//         const days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
//         data['Days'] = days.toString();
//         data['Nights'] = (days - 1).toString();
//       } else {
//         data['Days'] = ''; data['Nights'] = '';
//       }
//     } else {
//       data['Days'] = ''; data['Nights'] = '';
//     }

//     // Net Cost
//     let totalNet = 0;
//     const costingFields = ['Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals', 'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips'];
//     costingFields.forEach(f => {
//       totalNet += (data[f] === 'N/A' ? 0 : parseFloat(data[f]) || 0);
//     });
//     totalNet += extraCosts.reduce((acc, c) => acc + (parseFloat(c.value) || 0), 0);
//     data['Net Cost'] = totalNet.toFixed(2);

//     const noOfPax = parseFloat(data['No. of Pax']) || 1;

//     // === REVERSE: Gross % Target → Mark-up % ===
//     const grossTargetPercent = parseFloat(data['Gross % Target']) || 0;
//     let markupPercent = parseFloat(data['Mark-up %']) || 0;

//     if (grossTargetPercent > 0 && !data['Mark-up %']) {
//       // Solve: Gross Margin % = (Selling - Net - Comm - Trans) / Selling
//       // Let M = markup %, S = Net * (1 + M/100)
//       // Gross = S - Comm - Trans = S * (1 - agent% - trans%)
//       // Gross / S = target% → M derived
//       const agentPct = parseFloat(data['Less: Agent Commission %']) || 0;
//       const transPct = parseFloat(data['Less: Transaction Charges %']) || 0;
//       const deductPct = agentPct + transPct;

//       if (grossTargetPercent < 100 - deductPct) {
//         const targetGrossRatio = grossTargetPercent / 100;
//         const remaining = 1 - deductPct / 100;
//         const requiredSellingRatio = targetGrossRatio / remaining;
//         markupPercent = (requiredSellingRatio * 100) / (1 - requiredSellingRatio);
//         if (markupPercent >= 0) {
//           data['Mark-up %'] = markupPercent.toFixed(4);
//         }
//       }
//     }

//     // === Forward Calculation ===
//     const markup = totalNet * (markupPercent / 100);
//     data['Mark-up'] = markup.toFixed(2);

//     const sellingPrice = totalNet + markup;
//     data['Selling Price to Customer'] = sellingPrice.toFixed(2);
//     data['Per Pax Selling Price'] = (sellingPrice / noOfPax).toFixed(2);

//     const agentCommission = sellingPrice * (parseFloat(data['Less: Agent Commission %']) || 0) / 100;
//     data['Less: Agent Commission'] = agentCommission.toFixed(2);

//     const transactionCharges = sellingPrice * (parseFloat(data['Less: Transaction Charges %']) || 0) / 100;
//     data['Less: Transaction Charges'] = transactionCharges.toFixed(2);

//     const grossMargin = sellingPrice - totalNet - agentCommission - transactionCharges;
//     data['Gross Margin'] = grossMargin.toFixed(2);
//     data['Gross Margin %'] = sellingPrice > 0 ? ((grossMargin / sellingPrice) * 100).toFixed(2) : '0.00';

//     setFormData({ ...data });
//   };

//   // Correct currency conversion (direct currency-to-currency rate)
//   const getConversionRate = () => {
//     try {
//       // If rates are missing or currencies are same, return 1
//       if (!rates || !rates[currency] || !rates[convertedCurrency] || currency === convertedCurrency) return 1;

//       // API gives rates relative to USD → Example: rates["INR"] = 88.75
//       // Convert between any two currencies:
//       // value_in_target = value_in_main * (rate[target] / rate[main])
//       return rates[convertedCurrency] / rates[currency];
//     } catch (err) {
//       console.error('Conversion rate error:', err);
//       return 1;
//     }
//   };

//   // Convert values using the direct conversion rate
//   const convertValue = (value) => {
//     const v = parseFloat(value) || 0;
//     const r = getConversionRate();
//     return (v * r).toFixed(2);
//   };

//   // handle currency selection change and force recalculation
//   const handleCurrencyChange = (e, isMain = true) => {
//     const newCurrency = e.target.value;
//     if (isMain) {
//       setCurrency(newCurrency);
//     } else {
//       setConvertedCurrency(newCurrency);
//     }
//     // small timeout to ensure state updates before recalculation
//     setTimeout(() => calculate({ ...formData }), 50);
//   };

//   const addMember = () => setMembers([...members, '']);
//   const updateMember = (i, v) => {
//     const newM = [...members]; newM[i] = v; setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };
//   const removeMember = (i) => {
//     const newM = members.filter((_, idx) => idx !== i);
//     setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };

//   const addCostField = () => setExtraCosts([...extraCosts, { label: '', value: '' }]);
//   const updateCostField = (i, k, v) => {
//     const newCosts = [...extraCosts];
//     newCosts[i][k] = v;
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };
//   const removeCostField = (i) => {
//     const newCosts = extraCosts.filter((_, idx) => idx !== i);
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };

// const handleSubmit = async () => {
//   // Validation: must select an approver
//   if (!selectedApproverId) {
//     alert(`Please select a ${approverType === 'manager' ? 'Manager' : 'Functional Admin'} to assign.`);
//     return;
//   }

//   // Force latest exchange rates before submission
//   await fetchRates();
//   const rate = getConversionRate();

//   // Check if conversion is needed and rate is valid
//   if (convertedCurrency && convertedCurrency !== currency && rate <= 0) {
//     alert(
//       `No exchange rate available for ${currency} → ${convertedCurrency}. ` +
//       `Please wait a few seconds and try again.`
//     );
//     return;
//   }

//   // Prepare clean data (remove empty/invalid entries)
//   const dataToSubmit = {
//     ...formData,
//     'Travelling Members': members.filter(m => m?.trim()),           // only non-empty
//     'Extra Costs': extraCosts.filter(c => c?.label?.trim() && c?.value), // only valid costs
//   };

//   try {
//     const response = await submitPackage(user_id, {
//       data: dataToSubmit,
//       currency,
//       convertedCurrency: convertedCurrency || null,
//       exchangeRate: rate,
//       // Send both camelCase (primary) and snake_case (fallback) so server always picks them up
//       assignedApproverId: parseInt(selectedApproverId, 10),
//       assigned_approver_id: parseInt(selectedApproverId, 10),
//       approverRole: approverType,
//       approver_role: approverType,
//     });

//     if (response.data.success) {
//       alert('Package submitted successfully for approval!');
//       navigate('/dashboard/view-packages');
//     } else {
//       alert('Submission failed: ' + (response.data.error || 'Unknown error'));
//     }
//   } catch (error) {
//     console.error('Package submission error:', error);
//     alert(
//       'Failed to submit package.\n' +
//       (error.response?.data?.error || error.message || 'Please check your connection and try again.')
//     );
//   }
// };
//   const toggleNA = (field) => {
//     if (!isEditable) return;
//     const isNA = formData[`${field}_NA`];
//     const newData = { ...formData };
//     newData[`${field}_NA`] = !isNA;
//     newData[field] = !isNA ? 'N/A' : '';
//     setFormData(newData);
//     calculate(newData);
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-3xl font-bold mb-6">{referenceId ? `Package ${referenceId}` : 'Create Package'}</h2>

//         <div className="mb-6 flex items-end gap-20">

        
//           {/* Package Name */}
//           <div className="w-64">
//             <label className="block font-medium text-gray-700 mb-1">
//               Package Name:
//             </label>
//             <input
//               type="text"
//               name="Package Name"
//               value={formData["Package Name"] || ""}
//               onChange={handleChange}
//               placeholder="Enter Package Name"
//               className="p-2 border rounded w-full"
//               required
//               readOnly={!isEditable}
//             />
//           </div>

//         {/* Main Currency */}
//         <div className="w-48">
//           <label className="block font-medium text-gray-700 mb-1">
//             Main Currency:
//           </label>
//           <select
//             value={currency}
//             onChange={(e) => handleCurrencyChange(e, true)}
//             className="p-2 border rounded w-full"
//             disabled={!isEditable}
//           >
//             {Object.keys(symbols).map((c) => (
//               <option key={c} value={c}>
//                 {c} ({symbols[c]})
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Approver Type */}
//         <div className="w-48">
//           <label className="block font-medium text-gray-700 mb-1">
//             Approver Type:
//           </label>
//           <select
//             value={approverType}
//             onChange={(e) => { setApproverType(e.target.value); setSelectedApproverId(''); }}
//             className="p-2 border rounded w-full"
//             disabled={!isEditable}
//           >
//             <option value="manager">Manager</option>
//             <option value="functional_admin">Functional Admin</option>
//           </select>
//         </div>

//         {/* Select Approver */}
//         <div className="w-64">
//           <label className="block font-medium text-gray-700 mb-1">
//             Select {approverType.charAt(0).toUpperCase() +
//               approverType.slice(1).replace("_", " ")}:
//           </label>
//           <select
//             value={selectedApproverId}
//             onChange={(e) => setSelectedApproverId(e.target.value)}
//             className="p-2 border rounded w-full"
//             disabled={!isEditable}
//           >
//             <option value="">Select...</option>
//             {(approverType === "manager" ? managers : functionalAdmins).map(
//               (approver) => (
//                 <option key={approver.id} value={approver.id}>
//                   {approver.name || approver.username} ({approver.email})
//                 </option>
//               )
//             )}
//           </select>
//         </div>

//         </div>

//       <div className="bg-white p-8 rounded shadow">
//           {/* ✅ Show Converted Currency Toggle (ONLY ONE TIME) */}

//         {sectionOrder.map(section => (
//           <div key={section} className="mb-8">
//             <h3 className="text-xl font-semibold mb-4">{section}</h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {sections[section]?.map(field => (
//                 <div key={field.id}>
//                   <label className="block text-gray-700 mb-2">
//                     {field.field_name}{field.is_required ? ' *' : ''}
//                   </label>
//                   <div className="flex items-center">
//                     {field.field_type === 'date' ? (
//                       <input
//                         type="date"
//                         name={field.field_name}
//                         value={formData[field.field_name] || ''}
//                         onChange={handleChange}
//                         readOnly={!isEditable}
//                         min={todayISO}
//                         className="w-full p-2 border rounded"
//                         required={field.is_required}
//                       />
//                     ) : field.field_type === 'checkbox' ? (
//                       <input
//                         type="checkbox"
//                         name={field.field_name}
//                         checked={!!formData[field.field_name]}
//                         onChange={handleChange}
//                         disabled={!isEditable}
//                         className="h-4 w-4"
//                       />
//                     ) : (
//                       <>
//                         <input
//                           type={field.field_type}
//                           name={field.field_name}
//                           value={formData[field.field_name] || ''}
//                           onChange={handleChange}
//                           readOnly={isCalculated(field.field_name) || !isEditable}
//                           className={`w-full p-2 border rounded ${field.field_name.includes('Gross Margin') ? 'font-bold' : ''}`}
//                           required={field.is_required}
//                         />
//                         {moneyFields.includes(field.field_name) && (
//                           <span className="ml-2">{symbols[currency]}</span>
//                         )}
//                       </>
//                     )}
//                   </div>

//                   {section === 'Package Costing' && field.field_type === 'number' && (
//                     <div className="mt-1 text-sm">
//                       <label className="inline-flex items-center gap-2">
//                         <input
//                           type="checkbox"
//                           name={`${field.field_name}_NA`}
//                           checked={!!formData[`${field.field_name}_NA`]}
//                           onChange={() => toggleNA(field.field_name)}
//                           disabled={!isEditable}
//                         />
//                         <span className="text-gray-600">Mark as N/A</span>
//                       </label>
//                     </div>
//                   )}
//                 </div>
//               ))}

//               {/* === MARGIN CALCULATION: THIRD COLUMN === */}
//          {/* === MARGIN CALCULATION: THIRD COLUMN === */}
// {section === 'Margin Calculation' && showConverted && (
//   <div className="col-span-2 mt-6">
//     <div className="grid grid-cols-1 gap-6 border-t pt-6">

//       {/* Converted Currency Dropdown */}
//       <div>
//         <label className="font-medium text-gray-700">Converted Currency:</label>
//         <select
//           value={convertedCurrency}
//           onChange={(e) => handleCurrencyChange(e, false)}
//           className="p-2 border rounded w-full mt-1"
//           disabled={!isEditable}
//         >
//           {Object.keys(symbols).map(c => (
//             <option key={c} value={c}>{c} ({symbols[c]})</option>
//           ))}
//         </select>
//       </div>

//       {/* Converted Column */}
//       <div className="col-span-1">
//         <h4 className="font-semibold text-lg mb-3 text-center">
//           Converted ({symbols[convertedCurrency]})
//         </h4>
//         {convertedFields.map(f => (
//           <div key={f} className="mb-3">
//             <label className="block text-gray-600 text-sm">{f}</label>
//             <div className="flex items-center">
//               <input
//                 type="text"
//                 value={convertValue(formData[f])}
//                 readOnly
//                 className="w-full p-2 border rounded bg-gray-50"
//               />
//               <span className="ml-2">{symbols[convertedCurrency]}</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Info */}
//       <div className="text-sm text-gray-500">
//         <p>Conversion uses live exchange rates (direct currency-to-currency conversion).</p>
//         <p className="mt-1">Rate: 1 {currency} → {(getConversionRate()).toFixed(4)} {convertedCurrency}</p>
//       </div>

//     </div>
//   </div>
// )}

//         {section === 'Customer Info' && (
//   <div className="col-span-2">

//     {/* Header with NA toggle */}
//     <div className="flex items-center justify-between mt-4 mb-2">
//       <h4>Travelling Members (Optional)</h4>

//       <label className="flex items-center gap-2 text-sm cursor-pointer">
//         <input
//           type="checkbox"
//           checked={isMembersNA}
//           onChange={() => setIsMembersNA(!isMembersNA)}
//           disabled={!isEditable}
//         />
//         NA
//       </label>
//     </div>

//     {/* Show members ONLY if NA is unchecked */}
//     {!isMembersNA && (
//       <>
//         {members.map((m, i) => (
//           <div key={i} className="flex gap-2 mb-2">
//             <input
//               type="text"
//               value={m}
//               onChange={(e) => updateMember(i, e.target.value)}
//               className="flex-1 p-2 border rounded"
//               readOnly={!isEditable}
//             />
//             <button
//               type="button"
//               onClick={() => removeMember(i)}
//               className="text-red-600 text-sm"
//               disabled={!isEditable}
//             >
//               Remove
//             </button>
//           </div>
//         ))}

//         <button
//           type="button"
//           onClick={addMember}
//           className="text-sm text-blue-600 underline"
//           disabled={!isEditable}
//         >
//           + Add Member
//         </button>
//       </>
//     )}

//     {/* NA Text */}
//     {isMembersNA && (
//       <p className="text-gray-500 text-sm italic">Not Applicable</p>
//     )}
//   </div>
// )}


//               {section === 'Package Costing' && (
//                 <div className="col-span-2 mt-4">
//                   <h4 className="mb-2">Extra Costs</h4>
//                   {extraCosts.map((c, i) => (
//                     <div key={i} className="flex gap-2 mb-2">
//                       <input
//                         type="text"
//                         value={c.label}
//                         onChange={(e) => updateCostField(i, 'label', e.target.value)}
//                         placeholder="Cost Label"
//                         className="flex-1 p-2 border rounded"
//                         readOnly={!isEditable}
//                       />
//                       <div className="flex items-center">
//                         <input
//                           type="number"
//                           value={c.value}
//                           onChange={(e) => updateCostField(i, 'value', e.target.value)}
//                           placeholder="Amount"
//                           className="w-32 p-2 border rounded"
//                           readOnly={!isEditable}
//                         />
//                         <span className="ml-2">{symbols[currency]}</span>
//                       </div>
//                       <button
//                         type="button"
//                         onClick={() => removeCostField(i)}
//                         className="text-red-600 text-sm"
//                         disabled={!isEditable}
//                       >
//                         Remove
//                       </button>
//                     </div>
//                   ))}
//                   <button
//                     type="button"
//                     onClick={addCostField}
//                     className="text-sm text-blue-600 underline"
//                     disabled={!isEditable}
//                   >
//                     + Add Cost Field
//                   </button>
//                 </div>
//               )}

//               {section === 'Administrative' && (
//                 <div className="col-span-2">
//                   <div className="flex gap-4 items-center">
//                     <button
//                       type="button"
//                       onClick={handleSubmit}
//                       className={`bg-green-500 text-white px-6 py-2 rounded ${!isEditable ? 'opacity-60 cursor-not-allowed' : ''}`}
//                       disabled={!isEditable}
//                     >
//                       Submit for Approval
//                     </button>

//                     {role !== 'employee' && location.state?.package?.status === 'approved' && (
//                       <button
//                         type="button"
//                         onClick={() => {
//                           const pkg = location.state.package;
//                           const newData = { ...pkg.data };
//                           delete newData['Invoice Reference'];
//                           setReferenceId(null);
//                           setFormData(newData);
//                           setMembers(pkg.data?.['Travelling Members'] || []);
//                           setExtraCosts(pkg.data?.['Extra Costs'] || []);
//                           setIsEditable(true);
//                           alert('New package created from approved one.');
//                         }}
//                         className="bg-indigo-600 text-white px-4 py-2 rounded"
//                       >
//                         Create New Package
//                       </button>
//                     )}
//                   </div>

//                   {!isEditable && (
//                     <div className="text-sm text-red-600 mt-2">Package is approved and frozen.</div>
//                   )}

//                   <div className="mt-4 text-sm text-gray-600">
//                     <div>
//                       Rates: {rates[currency] ? `1 USD = ${rates[currency].toFixed(4)} ${currency}` : 'Offline'}
//                     </div>
//                     <div>
//                       Source: <a href="https://www.xe.com" target="_blank" rel="noreferrer" className="underline text-blue-600">XE.com</a>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
// <div className="flex items-center gap-3 mb-6">
//   <span className="font-medium text-gray-700">
//     Show Converted Currency
//   </span>

//   <label className="relative inline-flex items-center cursor-pointer">
//     <input
//       type="checkbox"
//       className="sr-only peer"
//       checked={showConverted}
//       onChange={() => setShowConverted(!showConverted)}
//     />

//     {/* Track */}
//     <div className="w-12 h-6 bg-gray-300 rounded-full 
//         peer-checked:bg-green-500 transition-colors duration-300">
//     </div>

//     {/* Knob */}
//     <div
//       className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full 
//       transition-transform duration-300
//       peer-checked:translate-x-6 shadow-md">
//     </div>
//   </label>
// </div>


//       </div>
//     </div>
//   );
// };

// export default PackageForm;
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { submitPackage, sendNotification, fetchRatesApi, getManagers,getFunctionalAdmins} from '../services/api';

// const PackageForm = () => {
//   const [formData, setFormData] = useState({});
//   const [members, setMembers] = useState([]);
//   const [extraCosts, setExtraCosts] = useState([]);
//   const [referenceId, setReferenceId] = useState(null);
//   const [isEditable, setIsEditable] = useState(true);
//   const [sections, setSections] = useState({});
//   const [originalValues, setOriginalValues] = useState({});
//   const [currency, setCurrency] = useState('USD');
//   const [convertedCurrency, setConvertedCurrency] = useState('INR'); // Default secondary
//   const [rates, setRates] = useState({});
//   const [symbols] = useState({ USD: '$', INR: '₹', EUR: '€', JPY: '¥', CAD: 'CA$' });
//   const navigate = useNavigate();
//   const location = useLocation();
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id') || '0', 10);
//   const [showConverted, setShowConverted] = useState(false);
//   const [managers, setManagers] = useState([]);
//   const [selectedManagerId, setSelectedManagerId] = useState('');
// const [isMembersNA, setIsMembersNA] = useState(false);
// const [approverType, setApproverType] = useState('manager');
// const [functionalAdmins, setFunctionalAdmins] = useState([]);
// const [selectedApproverId, setSelectedApproverId] = useState('');
//   // order and money fields
//   const sectionOrder = [
//     'Employee Info',
//     'Agent Info',
//     'Customer Info',
//     'Duration',
//     'Package Costing',
//     'Margin Calculation',
//     'Administrative'
//   ];

//   const moneyFields = [
//     'Flights / Airfare',
//     'Accommodation',
//     'Transfers',
//     'Sightseeing',
//     'Meals',
//     'Visa Fees',
//     'Travel Insurance',
//     'Guide / Driver Tips',
//     'Net Cost',
//     'Selling Price to Customer',
//     'Per Pax Selling Price',
//     'Mark-up',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   const convertedFields = [
//     'Mark-up',
//     'Per Pax Selling Price',
//     'Less: Agent Commission',
//     'Less: Transaction Charges',
//     'Gross Margin'
//   ];

//   // fetch rates once and keep updated periodically
//   useEffect(() => {
//     const initial = async () => {
//       await fetchRates();
//     };
//     initial();
//     const id = setInterval(fetchRates, 10 * 60 * 1000);
//     return () => clearInterval(id);
//   }, []);
// useEffect(() => {
//   const fetchApprovers = async () => {
//     try {
//       const managersRes = await getManagers();
//       setManagers(managersRes.data.managers || []);

//       const functionalRes = await getFunctionalAdmins();
//       setFunctionalAdmins(functionalRes.data.managers || []);  // Assuming backend returns 'managers' key; adjust if needed
//     } catch (err) {
//       console.error('Failed to fetch approvers:', err);
//     }
//   };
//   fetchApprovers();
// }, []);
//   const fetchRates = async () => {
//     try {
//       if (fetchRatesApi) {
//         const r = await fetchRatesApi();
//         setRates(r || {});
//         return;
//       }
//       const res = await fetch(`https://open.er-api.com/v6/latest/USD`);
//       const data = await res.json();
//       if (data.rates) setRates(data.rates || {});
//     } catch (err) {
//       console.error("Failed to fetch rates:", err);
//     }
//   };

//   useEffect(() => {
//     const allFields = [
//       { id: 1, section: 'Employee Info', field_name: 'Employee Name', field_type: 'text', is_required: true },
//       { id: 2, section: 'Employee Info', field_name: 'Employee Code', field_type: 'text', is_required: true },
//       { id: 3, section: 'Agent Info', field_name: 'Agent Name', field_type: 'text', is_required: true },
//       { id: 4, section: 'Agent Info', field_name: 'Agency Name', field_type: 'text', is_required: true },
//       { id: 5, section: 'Agent Info', field_name: 'Agent Number', field_type: 'text', is_required: true },
//       { id: 6, section: 'Agent Info', field_name: 'Agent Email', field_type: 'email', is_required: true },
//       { id: 8, section: 'Customer Info', field_name: 'Customer Name', field_type: 'text', is_required: true },
//       { id: 13, section: 'Customer Info', field_name: 'No. of Pax', field_type: 'number', is_required: true },
//       { id: 9, section: 'Customer Info', field_name: 'Customer Email', field_type: 'email', is_required: false },
//       { id: 10, section: 'Customer Info', field_name: 'Customer Mobile', field_type: 'text', is_required: false },
//       { id: 11, section: 'Customer Info', field_name: 'Start Date', field_type: 'date', is_required: true },
//       { id: 12, section: 'Customer Info', field_name: 'End Date', field_type: 'date', is_required: true },
//       { id: 14, section: 'Duration', field_name: 'Days', field_type: 'number', is_required: true },
//       { id: 15, section: 'Duration', field_name: 'Nights', field_type: 'number', is_required: true },

//       // costing
//       { id: 16, section: 'Package Costing', field_name: 'Flights / Airfare', field_type: 'number' },
//       { id: 17, section: 'Package Costing', field_name: 'Accommodation', field_type: 'number' },
//       { id: 18, section: 'Package Costing', field_name: 'Transfers', field_type: 'number' },
//       { id: 19, section: 'Package Costing', field_name: 'Sightseeing', field_type: 'number' },
//       { id: 20, section: 'Package Costing', field_name: 'Meals', field_type: 'number' },
//       { id: 21, section: 'Package Costing', field_name: 'Visa Fees', field_type: 'number' },
//       { id: 22, section: 'Package Costing', field_name: 'Travel Insurance', field_type: 'number' },
//       { id: 23, section: 'Package Costing', field_name: 'Guide / Driver Tips', field_type: 'number' },
//       { id: 24, section: 'Package Costing', field_name: 'Net Cost', field_type: 'number' },

//       // margin
//       { id: 25, section: 'Margin Calculation', field_name: 'Mark-up %', field_type: 'number' },
//       { id: 26, section: 'Margin Calculation', field_name: 'Mark-up', field_type: 'number' },
//       { id: 27, section: 'Margin Calculation', field_name: 'Selling Price to Customer', field_type: 'number' },
//       { id: 28, section: 'Margin Calculation', field_name: 'Per Pax Selling Price', field_type: 'number' },
//       { id: 29, section: 'Margin Calculation', field_name: 'Less: Agent Commission %', field_type: 'number' },
//       { id: 30, section: 'Margin Calculation', field_name: 'Less: Agent Commission', field_type: 'number' },
//       { id: 31, section: 'Margin Calculation', field_name: 'Less: Transaction Charges %', field_type: 'number' },
//       { id: 32, section: 'Margin Calculation', field_name: 'Less: Transaction Charges', field_type: 'number' },
//       { id: 33, section: 'Margin Calculation', field_name: 'Gross Margin %', field_type: 'number' },
//       { id: 34, section: 'Margin Calculation', field_name: 'Gross Margin', field_type: 'number' },
//       // { id: 35, section: 'Margin Calculation', field_name: 'Gross % Target', field_type: 'number' }, // NEW

//       ...(role !== 'employee' ? [] : []),
//     ];

//     const grouped = allFields.reduce((acc, field) => {
//       if (!acc[field.section]) acc[field.section] = [];
//       acc[field.section].push(field);
//       return acc;
//     }, {});

//     setFormData(allFields.reduce((acc, f) => ({ ...acc, [f.field_name]: f.field_type === 'checkbox' ? false : '' }), {}));
//     setSections(grouped);

//     if (location.state?.package) {
//       const pkg = location.state.package;
//       setReferenceId(pkg.reference_id);
//       setFormData(prev => ({ ...prev, ...(pkg.data || {}) }));
//       setMembers(pkg.data?.['Travelling Members'] || []);
//       setExtraCosts(pkg.data?.['Extra Costs'] || []);
//       setCurrency(pkg.currency || 'USD');
//       setConvertedCurrency(pkg.converted_currency || 'INR');
//       setOriginalValues(
//         moneyFields.reduce((acc, f) => ({ ...acc, [f]: parseFloat(pkg.data?.[f] || 0) }), {})
//       );

//       if (pkg.status === 'approved') {
//         setIsEditable(false);
//       }
//     }
//   }, [location.state]);

//   const isCalculated = (fieldName) =>
//     ['Net Cost', 'Selling Price to Customer', 'Per Pax Selling Price', 'Gross Margin', 'Gross Margin %', 'Mark-up', 'Less: Agent Commission', 'Days', 'Nights'].includes(fieldName);

//   const todayISO = new Date().toISOString().split('T')[0];

//   const handleChange = (e) => {
//     if (!isEditable) return;
//     const { name, value, type, checked } = e.target;
//     const val = type === 'checkbox' ? checked : value;
//     const newData = { ...formData, [name]: val };

//     if (name.endsWith('_NA')) {
//       const fieldName = name.replace('_NA', '');
//       if (val) {
//         newData[fieldName] = 'N/A';
//         setOriginalValues(prev => ({ ...prev, [fieldName]: 0 }));
//       } else {
//         newData[fieldName] = '';
//       }
//     }

//     if (moneyFields.includes(name) || name === 'Less: Transaction Charges %') {
//       setOriginalValues(prev => ({ ...prev, [name]: parseFloat(val) || 0 }));
//     }

//     setFormData(newData);
//     calculate(newData);
//   };

//   const calculate = (data) => {
//     // Days & Nights
//     if (data['Start Date'] && data['End Date']) {
//       const startDate = new Date(data['Start Date']);
//       const endDate = new Date(data['End Date']);
//       startDate.setHours(0, 0, 0, 0); endDate.setHours(0, 0, 0, 0);
//       if (endDate >= startDate) {
//         const days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
//         data['Days'] = days.toString();
//         data['Nights'] = (days - 1).toString();
//       } else {
//         data['Days'] = ''; data['Nights'] = '';
//       }
//     } else {
//       data['Days'] = ''; data['Nights'] = '';
//     }

//     // Net Cost
//     let totalNet = 0;
//     const costingFields = ['Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals', 'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips'];
//     costingFields.forEach(f => {
//       totalNet += (data[f] === 'N/A' ? 0 : parseFloat(data[f]) || 0);
//     });
//     totalNet += extraCosts.reduce((acc, c) => acc + (parseFloat(c.value) || 0), 0);
//     data['Net Cost'] = totalNet.toFixed(2);

//     const noOfPax = parseFloat(data['No. of Pax']) || 1;

//     // === REVERSE: Gross % Target → Mark-up % ===
//     const grossTargetPercent = parseFloat(data['Gross % Target']) || 0;
//     let markupPercent = parseFloat(data['Mark-up %']) || 0;

//     if (grossTargetPercent > 0 && !data['Mark-up %']) {
//       // Solve: Gross Margin % = (Selling - Net - Comm - Trans) / Selling
//       // Let M = markup %, S = Net * (1 + M/100)
//       // Gross = S - Comm - Trans = S * (1 - agent% - trans%)
//       // Gross / S = target% → M derived
//       const agentPct = parseFloat(data['Less: Agent Commission %']) || 0;
//       const transPct = parseFloat(data['Less: Transaction Charges %']) || 0;
//       const deductPct = agentPct + transPct;

//       if (grossTargetPercent < 100 - deductPct) {
//         const targetGrossRatio = grossTargetPercent / 100;
//         const remaining = 1 - deductPct / 100;
//         const requiredSellingRatio = targetGrossRatio / remaining;
//         markupPercent = (requiredSellingRatio * 100) / (1 - requiredSellingRatio);
//         if (markupPercent >= 0) {
//           data['Mark-up %'] = markupPercent.toFixed(4);
//         }
//       }
//     }

//     // === Forward Calculation ===
//     const markup = totalNet * (markupPercent / 100);
//     data['Mark-up'] = markup.toFixed(2);

//     const sellingPrice = totalNet + markup;
//     data['Selling Price to Customer'] = sellingPrice.toFixed(2);
//     data['Per Pax Selling Price'] = (sellingPrice / noOfPax).toFixed(2);

//     const agentCommission = sellingPrice * (parseFloat(data['Less: Agent Commission %']) || 0) / 100;
//     data['Less: Agent Commission'] = agentCommission.toFixed(2);

//     const transactionCharges = sellingPrice * (parseFloat(data['Less: Transaction Charges %']) || 0) / 100;
//     data['Less: Transaction Charges'] = transactionCharges.toFixed(2);

//     const grossMargin = sellingPrice - totalNet - agentCommission - transactionCharges;
//     data['Gross Margin'] = grossMargin.toFixed(2);
//     data['Gross Margin %'] = sellingPrice > 0 ? ((grossMargin / sellingPrice) * 100).toFixed(2) : '0.00';

//     setFormData({ ...data });
//   };

//   // Correct currency conversion (direct currency-to-currency rate)
//   const getConversionRate = () => {
//     try {
//       // If rates are missing or currencies are same, return 1
//       if (!rates || !rates[currency] || !rates[convertedCurrency] || currency === convertedCurrency) return 1;

//       // API gives rates relative to USD → Example: rates["INR"] = 88.75
//       // Convert between any two currencies:
//       // value_in_target = value_in_main * (rate[target] / rate[main])
//       return rates[convertedCurrency] / rates[currency];
//     } catch (err) {
//       console.error('Conversion rate error:', err);
//       return 1;
//     }
//   };

//   // Convert values using the direct conversion rate
//   const convertValue = (value) => {
//     const v = parseFloat(value) || 0;
//     const r = getConversionRate();
//     return (v * r).toFixed(2);
//   };

//   // handle currency selection change and force recalculation
//   const handleCurrencyChange = (e, isMain = true) => {
//     const newCurrency = e.target.value;
//     if (isMain) {
//       setCurrency(newCurrency);
//     } else {
//       setConvertedCurrency(newCurrency);
//     }
//     // small timeout to ensure state updates before recalculation
//     setTimeout(() => calculate({ ...formData }), 50);
//   };

//   const addMember = () => setMembers([...members, '']);
//   const updateMember = (i, v) => {
//     const newM = [...members]; newM[i] = v; setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };
//   const removeMember = (i) => {
//     const newM = members.filter((_, idx) => idx !== i);
//     setMembers(newM);
//     setFormData({ ...formData, 'Travelling Members': newM });
//   };

//   const addCostField = () => setExtraCosts([...extraCosts, { label: '', value: '' }]);
//   const updateCostField = (i, k, v) => {
//     const newCosts = [...extraCosts];
//     newCosts[i][k] = v;
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };
//   const removeCostField = (i) => {
//     const newCosts = extraCosts.filter((_, idx) => idx !== i);
//     setExtraCosts(newCosts);
//     setFormData({ ...formData, 'Extra Costs': newCosts });
//     calculate({ ...formData, 'Extra Costs': newCosts });
//   };

// const handleSubmit = async () => {
//   // Validation: must select an approver
//   if (!selectedApproverId) {
//     alert(`Please select a ${approverType === 'manager' ? 'Manager' : 'Functional Admin'} to assign.`);
//     return;
//   }

//   // Force latest exchange rates before submission
//   await fetchRates();
//   const rate = getConversionRate();

//   // Check if conversion is needed and rate is valid
//   if (convertedCurrency && convertedCurrency !== currency && rate <= 0) {
//     alert(
//       `No exchange rate available for ${currency} → ${convertedCurrency}. ` +
//       `Please wait a few seconds and try again.`
//     );
//     return;
//   }

//   // Prepare clean data (remove empty/invalid entries)
//   const dataToSubmit = {
//     ...formData,
//     'Travelling Members': members.filter(m => m?.trim()),           // only non-empty
//     'Extra Costs': extraCosts.filter(c => c?.label?.trim() && c?.value), // only valid costs
//   };

//   try {
//     const response = await submitPackage(user_id, {
//       data: dataToSubmit,
//       currency,
//       convertedCurrency: convertedCurrency || null,
//       exchangeRate: rate,
//       // Send both camelCase (primary) and snake_case (fallback) so server always picks them up
//       assignedApproverId: parseInt(selectedApproverId, 10),
//       assigned_approver_id: parseInt(selectedApproverId, 10),
//       approverRole: approverType,
//       approver_role: approverType,
//     });

//     if (response.data.success) {
//       alert('Package submitted successfully for approval!');
//       navigate('/dashboard/view-packages');
//     } else {
//       alert('Submission failed: ' + (response.data.error || 'Unknown error'));
//     }
//   } catch (error) {
//     console.error('Package submission error:', error);
//     alert(
//       'Failed to submit package.\n' +
//       (error.response?.data?.error || error.message || 'Please check your connection and try again.')
//     );
//   }
// };
//   const toggleNA = (field) => {
//     if (!isEditable) return;
//     const isNA = formData[`${field}_NA`];
//     const newData = { ...formData };
//     newData[`${field}_NA`] = !isNA;
//     newData[field] = !isNA ? 'N/A' : '';
//     setFormData(newData);
//     calculate(newData);
//   };

//   return (
//     <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">{referenceId ? `Package ${referenceId}` : 'Create Package'}</h2>

//       {/* Top Controls */}
//       <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">

//         {/* Package Name */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Package Name</label>
//           <input
//             type="text"
//             name="Package Name"
//             value={formData["Package Name"] || ""}
//             onChange={handleChange}
//             placeholder="Enter Package Name"
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             required
//             readOnly={!isEditable}
//           />
//         </div>

//         {/* Main Currency */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Main Currency</label>
//           <select
//             value={currency}
//             onChange={(e) => handleCurrencyChange(e, true)}
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             disabled={!isEditable}
//           >
//             {Object.keys(symbols).map((c) => (
//               <option key={c} value={c}>{c} ({symbols[c]})</option>
//             ))}
//           </select>
//         </div>

//         {/* Approver Type */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Approver Type</label>
//           <select
//             value={approverType}
//             onChange={(e) => { setApproverType(e.target.value); setSelectedApproverId(''); }}
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             disabled={!isEditable}
//           >
//             <option value="manager">Manager</option>
//             <option value="functional_admin">Functional Admin</option>
//           </select>
//         </div>

//         {/* Select Approver */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Select {approverType === 'manager' ? 'Manager' : 'Functional Admin'}
//           </label>
//           <select
//             value={selectedApproverId}
//             onChange={(e) => setSelectedApproverId(e.target.value)}
//             className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//             disabled={!isEditable}
//           >
//             <option value="">Select...</option>
//             {(approverType === "manager" ? managers : functionalAdmins).map((approver) => (
//               <option key={approver.id} value={approver.id}>
//                 {approver.name || approver.username} ({approver.email})
//               </option>
//             ))}
//           </select>
//         </div>

//       </div>

//       <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-100">
//           {/* ✅ Show Converted Currency Toggle (ONLY ONE TIME) */}

//         {sectionOrder.map(section => (
//           <div key={section} className="mb-8">
//             <h3 className="text-lg sm:text-xl font-semibold mb-4 pb-2 border-b border-gray-200">{section}</h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//               {sections[section]?.map(field => (
//                 <div key={field.id} className="flex flex-col">
//                   <label className="block text-gray-700 text-sm font-medium mb-1.5">
//                     {field.field_name}{field.is_required ? ' *' : ''}
//                   </label>

//                   {field.field_type === 'date' ? (
//                     <input
//                       type="date"
//                       name={field.field_name}
//                       value={formData[field.field_name] || ''}
//                       onChange={handleChange}
//                       readOnly={!isEditable}
//                       min={todayISO}
//                       className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
//                       required={field.is_required}
//                     />
//                   ) : field.field_type === 'checkbox' ? (
//                     <div className="flex items-center h-10">
//                       <input
//                         type="checkbox"
//                         name={field.field_name}
//                         checked={!!formData[field.field_name]}
//                         onChange={handleChange}
//                         disabled={!isEditable}
//                         className="h-5 w-5 rounded border-gray-300 text-indigo-600"
//                       />
//                     </div>
//                   ) : (
//                     /* Input + currency symbol inline */
//                     <div className="relative flex items-center">
//                       {moneyFields.includes(field.field_name) && (
//                         <span className="absolute left-3 text-gray-500 text-sm font-medium pointer-events-none select-none">
//                           {symbols[currency]}
//                         </span>
//                       )}
//                       <input
//                         type={field.field_type}
//                         name={field.field_name}
//                         value={formData[field.field_name] || ''}
//                         onChange={handleChange}
//                         readOnly={isCalculated(field.field_name) || !isEditable}
//                         className={`w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
//                           ${moneyFields.includes(field.field_name) ? 'pl-7' : ''}
//                           ${field.field_name.includes('Gross Margin') ? 'font-bold bg-green-50' : ''}
//                           ${isCalculated(field.field_name) ? 'bg-gray-50 text-gray-600' : ''}
//                         `}
//                         required={field.is_required}
//                       />
//                     </div>
//                   )}

//                   {section === 'Package Costing' && field.field_type === 'number' && (
//                     <label className="inline-flex items-center gap-2 mt-2 cursor-pointer select-none">
//                       <input
//                         type="checkbox"
//                         name={`${field.field_name}_NA`}
//                         checked={!!formData[`${field.field_name}_NA`]}
//                         onChange={() => toggleNA(field.field_name)}
//                         disabled={!isEditable}
//                         className="h-4 w-4 rounded border-gray-300 text-indigo-600"
//                       />
//                       <span className="text-xs text-gray-500">Mark as N/A</span>
//                     </label>
//                   )}
//                 </div>
//               ))}

//               {/* === MARGIN CALCULATION: THIRD COLUMN === */}
//          {/* === MARGIN CALCULATION: THIRD COLUMN === */}
// {section === 'Margin Calculation' && showConverted && (
//   <div className="col-span-1 sm:col-span-2 mt-4 border-t border-gray-200 pt-4">
//     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//       {/* Converted Currency Dropdown */}
//       <div className="sm:col-span-2">
//         <label className="block text-sm font-medium text-gray-700 mb-1.5">Converted Currency:</label>
//         <select
//           value={convertedCurrency}
//           onChange={(e) => handleCurrencyChange(e, false)}
//           className="p-2.5 border border-gray-300 rounded-md text-sm w-full sm:w-48"
//           disabled={!isEditable}
//         >
//           {Object.keys(symbols).map(c => (
//             <option key={c} value={c}>{c} ({symbols[c]})</option>
//           ))}
//         </select>
//       </div>

//       {/* Converted fields */}
//       {convertedFields.map(f => (
//         <div key={f}>
//           <label className="block text-xs text-gray-500 mb-1.5">{f} ({symbols[convertedCurrency]})</label>
//           <div className="relative flex items-center">
//             <span className="absolute left-3 text-gray-500 text-sm pointer-events-none">{symbols[convertedCurrency]}</span>
//             <input
//               type="text"
//               value={convertValue(formData[f])}
//               readOnly
//               className="w-full p-2.5 pl-7 border border-gray-200 rounded-md text-sm bg-gray-50 text-gray-600"
//             />
//           </div>
//         </div>
//       ))}

//       {/* Info */}
//       <div className="sm:col-span-2 text-xs text-gray-400 bg-gray-50 rounded-md p-3">
//         <p>Live rates used for conversion.</p>
//         <p className="mt-0.5">Rate: 1 {currency} = {(getConversionRate()).toFixed(4)} {convertedCurrency}</p>
//       </div>

//     </div>
//   </div>
// )}

//         {section === 'Customer Info' && (
//   <div className="col-span-1 sm:col-span-2 mt-2">
//     <div className="flex items-center justify-between mb-3">
//       <h4 className="text-sm font-medium text-gray-700">Travelling Members <span className="text-gray-400 font-normal">(Optional)</span></h4>
//       <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
//         <input
//           type="checkbox"
//           checked={isMembersNA}
//           onChange={() => setIsMembersNA(!isMembersNA)}
//           disabled={!isEditable}
//           className="h-4 w-4 rounded border-gray-300"
//         />
//         <span className="text-gray-600">N/A</span>
//       </label>
//     </div>

//     {!isMembersNA && (
//       <>
//         {members.map((m, i) => (
//           <div key={i} className="flex gap-2 mb-2">
//             <input
//               type="text"
//               value={m}
//               onChange={(e) => updateMember(i, e.target.value)}
//               className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
//               readOnly={!isEditable}
//               placeholder={`Member ${i + 1}`}
//             />
//             <button
//               type="button"
//               onClick={() => removeMember(i)}
//               className="text-red-500 text-sm font-medium px-2 hover:text-red-700"
//               disabled={!isEditable}
//             >
//               Remove
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           onClick={addMember}
//           className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
//           disabled={!isEditable}
//         >
//           + Add Member
//         </button>
//       </>
//     )}
//     {isMembersNA && (
//       <p className="text-gray-400 text-sm italic">Not Applicable</p>
//     )}
//   </div>
// )}


//               {section === 'Package Costing' && (
//                 <div className="col-span-1 sm:col-span-2 mt-2">
//                   <h4 className="text-sm font-medium text-gray-700 mb-2">Extra Costs</h4>
//                   {extraCosts.map((c, i) => (
//                     <div key={i} className="flex flex-col sm:flex-row gap-2 mb-3">
//                       <input
//                         type="text"
//                         value={c.label}
//                         onChange={(e) => updateCostField(i, 'label', e.target.value)}
//                         placeholder="Cost Label"
//                         className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
//                         readOnly={!isEditable}
//                       />
//                       <div className="flex items-center gap-2">
//                         <div className="relative flex-1 sm:flex-none">
//                           <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">{symbols[currency]}</span>
//                           <input
//                             type="number"
//                             value={c.value}
//                             onChange={(e) => updateCostField(i, 'value', e.target.value)}
//                             placeholder="Amount"
//                             className="w-full sm:w-32 p-2.5 pl-7 border border-gray-300 rounded-md text-sm"
//                             readOnly={!isEditable}
//                           />
//                         </div>
//                         <button
//                           type="button"
//                           onClick={() => removeCostField(i)}
//                           className="text-red-500 text-sm font-medium whitespace-nowrap hover:text-red-700"
//                           disabled={!isEditable}
//                         >
//                           Remove
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                   <button
//                     type="button"
//                     onClick={addCostField}
//                     className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
//                     disabled={!isEditable}
//                   >
//                     + Add Cost Field
//                   </button>
//                 </div>
//               )}

//               {section === 'Administrative' && (
//                 <div className="col-span-1 sm:col-span-2 mt-2">
//                   <div className="flex flex-wrap gap-3 items-center">
//                     <button
//                       type="button"
//                       onClick={handleSubmit}
//                       className={`bg-green-500 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-green-600 transition-colors ${!isEditable ? 'opacity-60 cursor-not-allowed' : ''}`}
//                       disabled={!isEditable}
//                     >
//                       Submit for Approval
//                     </button>

//                     {role !== 'employee' && location.state?.package?.status === 'approved' && (
//                       <button
//                         type="button"
//                         onClick={() => {
//                           const pkg = location.state.package;
//                           const newData = { ...pkg.data };
//                           delete newData['Invoice Reference'];
//                           setReferenceId(null);
//                           setFormData(newData);
//                           setMembers(pkg.data?.['Travelling Members'] || []);
//                           setExtraCosts(pkg.data?.['Extra Costs'] || []);
//                           setIsEditable(true);
//                           alert('New package created from approved one.');
//                         }}
//                         className="bg-indigo-600 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
//                       >
//                         Create New Package
//                       </button>
//                     )}
//                   </div>

//                   {!isEditable && (
//                     <div className="text-sm text-red-600 mt-2">Package is approved and frozen.</div>
//                   )}

//                   <div className="mt-4 text-xs text-gray-500 bg-gray-50 rounded-md p-3">
//                     <div>Rates: {rates[currency] ? `1 USD = ${rates[currency].toFixed(4)} ${currency}` : 'Offline'}</div>
//                     <div className="mt-1">Source: <a href="https://www.xe.com" target="_blank" rel="noreferrer" className="underline text-blue-600">XE.com</a></div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
// <div className="flex items-center gap-3 mt-6 mb-2 p-3 bg-indigo-50 rounded-lg">
//   <span className="font-medium text-gray-700 text-sm">
//     Show Converted Currency
//   </span>

//   <label className="relative inline-flex items-center cursor-pointer">
//     <input
//       type="checkbox"
//       className="sr-only peer"
//       checked={showConverted}
//       onChange={() => setShowConverted(!showConverted)}
//     />
//     <div className="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-green-500 transition-colors duration-300"></div>
//     <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5 shadow-md"></div>
//   </label>
// </div>


//       </div>
//     </div>
//   );
// };

// export default PackageForm;
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { submitPackage, sendNotification, fetchRatesApi, getManagers,getFunctionalAdmins} from '../services/api';

const PackageForm = () => {
  const [formData, setFormData] = useState({});
  const [members, setMembers] = useState([]);
  const [extraCosts, setExtraCosts] = useState([]);
  const [referenceId, setReferenceId] = useState(null);
  const [isEditable, setIsEditable] = useState(true);
  const [sections, setSections] = useState({});
  const [originalValues, setOriginalValues] = useState({});
  const [currency, setCurrency] = useState('USD');
  const [convertedCurrency, setConvertedCurrency] = useState('INR'); // Default secondary
  const [rates, setRates] = useState({});
const [symbols] = useState({
  USD: '$',
  INR: '₹',
  EUR: '€',
  JPY: '¥',
  CAD: 'CA$',

  // Existing
  AUD: 'A$',
  GBP: '£',
  SGD: 'S$',
  AED: 'د.إ',
  CHF: 'Fr',
  THB: '฿',
  MYR: 'RM',
  ZAR: 'R',
  NZD: 'NZ$',
  SAR: '﷼',
  HKD: 'HK$',

  // 🔥 NEW ADD
  IDR: 'Rp',     // Indonesia
  LKR: 'Rs',     // Sri Lanka
  VND: '₫',      // Vietnam
  KHR: '៛',      // Cambodia
  PHP: '₱',      // Philippines
  MUR: '₨'       // Mauritius
});
const currencyOptions = Object.keys(symbols).sort();
  const navigate = useNavigate();
  const location = useLocation();
  const role = localStorage.getItem('role');
  const user_id = parseInt(localStorage.getItem('user_id') || '0', 10);
  const [showConverted, setShowConverted] = useState(false);
  const [managers, setManagers] = useState([]);
  const [selectedManagerId, setSelectedManagerId] = useState('');
const [isMembersNA, setIsMembersNA] = useState(false);
const [approverType, setApproverType] = useState('manager');
const [functionalAdmins, setFunctionalAdmins] = useState([]);
const [selectedApproverId, setSelectedApproverId] = useState('');
  // order and money fields
  const sectionOrder = [
    'Employee Info',
    'Agent Info',
    'Customer Info',
    'Duration',
    'Package Costing',
    'Margin Calculation',
    'Administrative'
  ];

  const moneyFields = [
    'Flights / Airfare',
    'Accommodation',
    'Transfers',
    'Sightseeing',
    'Meals',
    'Visa Fees',
    'Travel Insurance',
    'Guide / Driver Tips',
    'Net Cost',
    'Selling Price to Customer',
    'Per Pax Selling Price',
    'Mark-up',
    'Less: Agent Commission',
    'Less: Transaction Charges',
    'Gross Margin'
  ];

  const convertedFields = [
    'Mark-up',
    'Per Pax Selling Price',
    'Less: Agent Commission',
    'Less: Transaction Charges',
    'Gross Margin'
  ];

  // fetch rates once and keep updated periodically
  useEffect(() => {
    const initial = async () => {
      await fetchRates();
    };
    initial();
    const id = setInterval(fetchRates, 10 * 60 * 1000);
    return () => clearInterval(id);
  }, []);
useEffect(() => {
  const fetchApprovers = async () => {
    try {
      const managersRes = await getManagers();
      setManagers(managersRes.data.managers || []);

      const functionalRes = await getFunctionalAdmins();
      setFunctionalAdmins(functionalRes.data.managers || []);  // Assuming backend returns 'managers' key; adjust if needed
    } catch (err) {
      console.error('Failed to fetch approvers:', err);
    }
  };
  fetchApprovers();
}, []);
  const fetchRates = async () => {
    const FALLBACK = {
      USD: 1, INR: 83.5, EUR: 0.92, GBP: 0.79, AED: 3.67,
      JPY: 149.5, CAD: 1.36, AUD: 1.53, SGD: 1.34, CHF: 0.90,
      THB: 35.1, MYR: 4.72, ZAR: 18.6, NZD: 1.63, SAR: 3.75,
      HKD: 7.82, IDR: 15700, LKR: 325, VND: 24500, KHR: 4100,
      PHP: 56.5, MUR: 46.5,
    };
    // Primary: open.er-api.com — covers MUR + 150 currencies, no key required
    try {
      const res = await fetch('https://open.er-api.com/v6/latest/USD');
      if (res.ok) {
        const data = await res.json();
        if (data.result === 'success' && data.rates) {
          setRates({ ...FALLBACK, ...data.rates });
          return;
        }
      }
    } catch (err) {
      console.warn('open.er-api failed:', err.message);
    }
    // Secondary: fxapi.app
    try {
      const res = await fetch('https://open.er-api.com/v6/latest/USD');
      if (res.ok) {
        const data = await res.json();
        if (data.rates) { setRates({ ...FALLBACK, ...data.rates }); return; }
      }
    } catch (err) {
      console.warn('fxapi failed:', err.message);
    }
    // Last resort: static fallback (MUR always present)
    setRates(FALLBACK);
  };

  useEffect(() => {
    const allFields = [
      { id: 1, section: 'Employee Info', field_name: 'Employee Name', field_type: 'text', is_required: true },
      { id: 2, section: 'Employee Info', field_name: 'Employee Code', field_type: 'text', is_required: true },
      { id: 3, section: 'Agent Info', field_name: 'Agent Name', field_type: 'text', is_required: true },
      { id: 4, section: 'Agent Info', field_name: 'Agency Name', field_type: 'text', is_required: true },
      { id: 5, section: 'Agent Info', field_name: 'Agent Number', field_type: 'text', is_required: true },
      { id: 6, section: 'Agent Info', field_name: 'Agent Email', field_type: 'email', is_required: true },
      { id: 8, section: 'Customer Info', field_name: 'Customer Name', field_type: 'text', is_required: true },
      { id: 13, section: 'Customer Info', field_name: 'No. of Pax', field_type: 'number', is_required: true },
      { id: 9, section: 'Customer Info', field_name: 'Customer Email', field_type: 'email', is_required: false },
      { id: 10, section: 'Customer Info', field_name: 'Customer Mobile', field_type: 'text', is_required: false },
      { id: 11, section: 'Customer Info', field_name: 'Start Date', field_type: 'date', is_required: true },
      { id: 12, section: 'Customer Info', field_name: 'End Date', field_type: 'date', is_required: true },
      { id: 14, section: 'Duration', field_name: 'Days', field_type: 'number', is_required: true },
      { id: 15, section: 'Duration', field_name: 'Nights', field_type: 'number', is_required: true },

      // costing
      { id: 16, section: 'Package Costing', field_name: 'Flights / Airfare', field_type: 'number' },
      { id: 17, section: 'Package Costing', field_name: 'Accommodation', field_type: 'number' },
      { id: 18, section: 'Package Costing', field_name: 'Transfers', field_type: 'number' },
      { id: 19, section: 'Package Costing', field_name: 'Sightseeing', field_type: 'number' },
      { id: 20, section: 'Package Costing', field_name: 'Meals', field_type: 'number' },
      { id: 21, section: 'Package Costing', field_name: 'Visa Fees', field_type: 'number' },
      { id: 22, section: 'Package Costing', field_name: 'Travel Insurance', field_type: 'number' },
      { id: 23, section: 'Package Costing', field_name: 'Guide / Driver Tips', field_type: 'number' },
      { id: 24, section: 'Package Costing', field_name: 'Net Cost', field_type: 'number' },

      // margin
      { id: 25, section: 'Margin Calculation', field_name: 'Mark-up %', field_type: 'number' },
      { id: 26, section: 'Margin Calculation', field_name: 'Mark-up', field_type: 'number' },
      { id: 27, section: 'Margin Calculation', field_name: 'Selling Price to Customer', field_type: 'number' },
      { id: 28, section: 'Margin Calculation', field_name: 'Per Pax Selling Price', field_type: 'number' },
      { id: 29, section: 'Margin Calculation', field_name: 'Less: Agent Commission %', field_type: 'number' },
      { id: 30, section: 'Margin Calculation', field_name: 'Less: Agent Commission', field_type: 'number' },
      { id: 31, section: 'Margin Calculation', field_name: 'Less: Transaction Charges %', field_type: 'number' },
      { id: 32, section: 'Margin Calculation', field_name: 'Less: Transaction Charges', field_type: 'number' },
      { id: 33, section: 'Margin Calculation', field_name: 'Gross Margin %', field_type: 'number' },
      { id: 34, section: 'Margin Calculation', field_name: 'Gross Margin', field_type: 'number' },

      ...(role !== 'employee' ? [] : []),
    ];

    const grouped = allFields.reduce((acc, field) => {
      if (!acc[field.section]) acc[field.section] = [];
      acc[field.section].push(field);
      return acc;
    }, {});

    setFormData(allFields.reduce((acc, f) => ({ ...acc, [f.field_name]: f.field_type === 'checkbox' ? false : '' }), {}));
    setSections(grouped);

    if (location.state?.package) {
      const pkg = location.state.package;
      setReferenceId(pkg.reference_id);
      setFormData(prev => ({ ...prev, ...(pkg.data || {}) }));
      setMembers(pkg.data?.['Travelling Members'] || []);
      setExtraCosts(pkg.data?.['Extra Costs'] || []);
      setCurrency(pkg.currency || 'USD');
      setConvertedCurrency(pkg.converted_currency || 'INR');
      setOriginalValues(
        moneyFields.reduce((acc, f) => ({ ...acc, [f]: parseFloat(pkg.data?.[f] || 0) }), {})
      );

      if (pkg.status === 'approved') {
        setIsEditable(false);
      }
    }
  }, [location.state]);

  const isCalculated = (fieldName) =>
    ['Net Cost', 'Selling Price to Customer', 'Per Pax Selling Price', 'Gross Margin', 'Gross Margin %', 'Mark-up', 'Less: Agent Commission', 'Days', 'Nights'].includes(fieldName);

  const todayISO = new Date().toISOString().split('T')[0];

  const handleChange = (e) => {
    if (!isEditable) return;
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    const newData = { ...formData, [name]: val };

    if (name.endsWith('_NA')) {
      const fieldName = name.replace('_NA', '');
      if (val) {
        newData[fieldName] = 'N/A';
        setOriginalValues(prev => ({ ...prev, [fieldName]: 0 }));
      } else {
        newData[fieldName] = '';
      }
    }

    if (moneyFields.includes(name) || name === 'Less: Transaction Charges %') {
      setOriginalValues(prev => ({ ...prev, [name]: parseFloat(val) || 0 }));
    }

    setFormData(newData);
    calculate(newData);
  };

  const calculate = (data) => {
    // Days & Nights
    if (data['Start Date'] && data['End Date']) {
      const startDate = new Date(data['Start Date']);
      const endDate = new Date(data['End Date']);
      startDate.setHours(0, 0, 0, 0); endDate.setHours(0, 0, 0, 0);
      if (endDate >= startDate) {
        const days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
        data['Days'] = days.toString();
        data['Nights'] = (days - 1).toString();
      } else {
        data['Days'] = ''; data['Nights'] = '';
      }
    } else {
      data['Days'] = ''; data['Nights'] = '';
    }

    // Net Cost
    let totalNet = 0;
    const costingFields = ['Flights / Airfare', 'Accommodation', 'Transfers', 'Sightseeing', 'Meals', 'Visa Fees', 'Travel Insurance', 'Guide / Driver Tips'];
    costingFields.forEach(f => {
      totalNet += (data[f] === 'N/A' ? 0 : parseFloat(data[f]) || 0);
    });
    totalNet += extraCosts.reduce((acc, c) => acc + (parseFloat(c.value) || 0), 0);
    data['Net Cost'] = totalNet.toFixed(2);

    const noOfPax = parseFloat(data['No. of Pax']) || 1;

    const grossTargetPercent = parseFloat(data['Gross % Target']) || 0;
    let markupPercent = parseFloat(data['Mark-up %']) || 0;

    if (grossTargetPercent > 0 && !data['Mark-up %']) {
      const agentPct = parseFloat(data['Less: Agent Commission %']) || 0;
      const transPct = parseFloat(data['Less: Transaction Charges %']) || 0;
      const deductPct = agentPct + transPct;

      if (grossTargetPercent < 100 - deductPct) {
        const targetGrossRatio = grossTargetPercent / 100;
        const remaining = 1 - deductPct / 100;
        const requiredSellingRatio = targetGrossRatio / remaining;
        markupPercent = (requiredSellingRatio * 100) / (1 - requiredSellingRatio);
        if (markupPercent >= 0) {
          data['Mark-up %'] = markupPercent.toFixed(4);
        }
      }
    }

    const markup = totalNet * (markupPercent / 100);
    data['Mark-up'] = markup.toFixed(2);

    const sellingPrice = totalNet + markup;
    data['Selling Price to Customer'] = sellingPrice.toFixed(2);
    data['Per Pax Selling Price'] = (sellingPrice / noOfPax).toFixed(2);

    const agentCommission = sellingPrice * (parseFloat(data['Less: Agent Commission %']) || 0) / 100;
    data['Less: Agent Commission'] = agentCommission.toFixed(2);

    const transactionCharges = sellingPrice * (parseFloat(data['Less: Transaction Charges %']) || 0) / 100;
    data['Less: Transaction Charges'] = transactionCharges.toFixed(2);

    const grossMargin = sellingPrice - totalNet - agentCommission - transactionCharges;
    data['Gross Margin'] = grossMargin.toFixed(2);
    data['Gross Margin %'] = sellingPrice > 0 ? ((grossMargin / sellingPrice) * 100).toFixed(2) : '0.00';

    setFormData({ ...data });
  };

  const getConversionRate = (fromCurrency = currency, toCurrency = convertedCurrency, currentRates = rates) => {
    try {
      if (!currentRates || !currentRates[fromCurrency] || !currentRates[toCurrency] || fromCurrency === toCurrency) return 1;
      // API rates relative to USD: rate[target] / rate[from] = conversion factor
      return currentRates[toCurrency] / currentRates[fromCurrency];
    } catch (err) {
      console.error('Conversion rate error:', err);
      return 1;
    }
  };

  const convertValue = (value, fromCurrency = currency, toCurrency = convertedCurrency) => {
    const v = parseFloat(value) || 0;
    const r = getConversionRate(fromCurrency, toCurrency, rates);
    return (v * r).toFixed(2);
  };

  const handleCurrencyChange = (e, isMain = true) => {
    const newCurrency = e.target.value;
    if (isMain) {
      setCurrency(newCurrency);
    } else {
      setConvertedCurrency(newCurrency);
    }
    // No need to recalculate - numbers don't change, only display currency changes
    // convertValue() reads currency/convertedCurrency from state which updates on next render
  };

  const addMember = () => setMembers([...members, '']);
  const updateMember = (i, v) => {
    const newM = [...members]; newM[i] = v; setMembers(newM);
    setFormData({ ...formData, 'Travelling Members': newM });
  };
  const removeMember = (i) => {
    const newM = members.filter((_, idx) => idx !== i);
    setMembers(newM);
    setFormData({ ...formData, 'Travelling Members': newM });
  };

  const addCostField = () => setExtraCosts([...extraCosts, { label: '', value: '' }]);
  const updateCostField = (i, k, v) => {
    const newCosts = [...extraCosts];
    newCosts[i][k] = v;
    setExtraCosts(newCosts);
    setFormData({ ...formData, 'Extra Costs': newCosts });
    calculate({ ...formData, 'Extra Costs': newCosts });
  };
  const removeCostField = (i) => {
    const newCosts = extraCosts.filter((_, idx) => idx !== i);
    setExtraCosts(newCosts);
    setFormData({ ...formData, 'Extra Costs': newCosts });
    calculate({ ...formData, 'Extra Costs': newCosts });
  };

const handleSubmit = async () => {
  if (!selectedApproverId) {
    alert(`Please select a ${approverType === 'manager' ? 'Manager' : 'Functional Admin'} to assign.`);
    return;
  }

  await fetchRates();
  const rate = getConversionRate();

  if (convertedCurrency && convertedCurrency !== currency && rate <= 0) {
    alert(
      `No exchange rate available for ${currency} → ${convertedCurrency}. ` +
      `Please wait a few seconds and try again.`
    );
    return;
  }

  const dataToSubmit = {
    ...formData,
    'Travelling Members': members.filter(m => m?.trim()),
    'Extra Costs': extraCosts.filter(c => c?.label?.trim() && c?.value),
  };

  try {
    const response = await submitPackage(user_id, {
      data: dataToSubmit,
      currency,
      convertedCurrency: convertedCurrency || null,
      exchangeRate: rate,
      assignedApproverId: parseInt(selectedApproverId, 10),
      assigned_approver_id: parseInt(selectedApproverId, 10),
      approverRole: approverType,
      approver_role: approverType,
    });

    if (response.data.success) {
      alert('Package submitted successfully for approval!');
      navigate('/dashboard/view-packages');
    } else {
      alert('Submission failed: ' + (response.data.error || 'Unknown error'));
    }
  } catch (error) {
    console.error('Package submission error:', error);
    alert(
      'Failed to submit package.\n' +
      (error.response?.data?.error || error.message || 'Please check your connection and try again.')
    );
  }
};
  // Dynamic left padding based on symbol character length to prevent overlap
const getSymbolPadding = (sym) => {
  if (!sym) return '28px';

  const len = sym.length;

  if (len === 1) return '28px';     // $, ₹, ₱, ฿
  if (len === 2) return '34px';     // Fr, RM, Rp
  if (len === 3) return '40px';     // A$, NZ$, HK$
  return '48px';                    // د.إ etc
};

  const toggleNA = (field) => {
    if (!isEditable) return;
    const isNA = formData[`${field}_NA`];
    const newData = { ...formData };
    newData[`${field}_NA`] = !isNA;
    newData[field] = !isNA ? 'N/A' : '';
    setFormData(newData);
    calculate(newData);
  };

  return (
    <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
      <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">{referenceId ? `Package ${referenceId}` : 'Create Package'}</h2>

      {/* Top Controls */}
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">

        {/* Package Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Package Name</label>
          <input
            type="text"
            name="Package Name"
            value={formData["Package Name"] || ""}
            onChange={handleChange}
            placeholder="Enter Package Name"
            className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            required
            readOnly={!isEditable}
          />
        </div>

        {/* Main Currency */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Main Currency</label>
 <select
  value={currency}
  onChange={(e) => handleCurrencyChange(e, true)}
  className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
  disabled={!isEditable}
>
  {currencyOptions.map((c) => (
    <option key={c} value={c}>
      {c} ({symbols[c]})
    </option>
  ))}
</select>
        </div>

        {/* Approver Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Approver Type</label>
          <select
            value={approverType}
            onChange={(e) => { setApproverType(e.target.value); setSelectedApproverId(''); }}
            className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            disabled={!isEditable}
          >
            <option value="manager">Manager</option>
            <option value="functional_admin">Functional Admin</option>
          </select>
        </div>

        {/* Select Approver */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select {approverType === 'manager' ? 'Manager' : 'Functional Admin'}
          </label>
          <select
            value={selectedApproverId}
            onChange={(e) => setSelectedApproverId(e.target.value)}
            className="p-2.5 border border-gray-300 rounded-md w-full text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            disabled={!isEditable}
          >
            <option value="">Select...</option>
            {(approverType === "manager" ? managers : functionalAdmins).map((approver) => (
              <option key={approver.id} value={approver.id}>
                {approver.name || approver.username} ({approver.email})
              </option>
            ))}
          </select>
        </div>

      </div>

      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-100">
        {sectionOrder.map(section => (
          <div key={section} className="mb-8">
            <h3 className="text-lg sm:text-xl font-semibold mb-4 pb-2 border-b border-gray-200">{section}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {sections[section]?.map(field => (
                <div key={field.id} className="flex flex-col">
                  <label className="block text-gray-700 text-sm font-medium mb-1.5">
                    {field.field_name}{field.is_required ? ' *' : ''}
                  </label>

                  {field.field_type === 'date' ? (
                    <input
                      type="date"
                      name={field.field_name}
                      value={formData[field.field_name] || ''}
                      onChange={handleChange}
                      readOnly={!isEditable}
                      min={todayISO}
                      className="w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                      required={field.is_required}
                    />
                  ) : field.field_type === 'checkbox' ? (
                    <div className="flex items-center h-10">
                      <input
                        type="checkbox"
                        name={field.field_name}
                        checked={!!formData[field.field_name]}
                        onChange={handleChange}
                        disabled={!isEditable}
                        className="h-5 w-5 rounded border-gray-300 text-indigo-600"
                      />
                    </div>
                  ) : (
                    <div className="relative flex items-center">
                      {moneyFields.includes(field.field_name) && (
                        <span className="absolute left-3 text-gray-500 text-sm font-medium pointer-events-none select-none">
                          {symbols[currency]}
                        </span>
                      )}
                      <input
                        type={field.field_type}
                        name={field.field_name}
                        value={formData[field.field_name] || ''}
                        onChange={handleChange}
                        readOnly={isCalculated(field.field_name) || !isEditable}
                        style={moneyFields.includes(field.field_name) ? { paddingLeft: getSymbolPadding(symbols[currency]) } : {}}
                        className={`w-full p-2.5 border border-gray-300 rounded-md text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                          ${field.field_name.includes('Gross Margin') ? 'font-bold bg-green-50' : ''}
                          ${isCalculated(field.field_name) ? 'bg-gray-50 text-gray-600' : ''}
                        `}
                        required={field.is_required}
                      />
                    </div>
                  )}

                  {section === 'Package Costing' && field.field_type === 'number' && (
                    <label className="inline-flex items-center gap-2 mt-2 cursor-pointer select-none">
                      <input
                        type="checkbox"
                        name={`${field.field_name}_NA`}
                        checked={!!formData[`${field.field_name}_NA`]}
                        onChange={() => toggleNA(field.field_name)}
                        disabled={!isEditable}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600"
                      />
                      <span className="text-xs text-gray-500">Mark as N/A</span>
                    </label>
                  )}
                </div>
              ))}

{section === 'Margin Calculation' && showConverted && (
  <div className="col-span-1 sm:col-span-2 mt-4 border-t border-gray-200 pt-4">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

      <div className="sm:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">Converted Currency:</label>
     <select
  value={convertedCurrency}
  onChange={(e) => handleCurrencyChange(e, false)}
  className="p-2.5 border border-gray-300 rounded-md text-sm w-full sm:w-48"
  disabled={!isEditable}
>
  {currencyOptions.map((c) => (
    <option key={c} value={c}>
      {c} ({symbols[c]})
    </option>
  ))}
</select>
      </div>

      {convertedFields.map(f => (
        <div key={f}>
          <label className="block text-xs text-gray-500 mb-1.5">{f} ({symbols[convertedCurrency]})</label>
          <div className="relative flex items-center">
            <span className="absolute left-3 text-gray-500 text-sm pointer-events-none">{symbols[convertedCurrency]}</span>
            <input
              type="text"
              value={convertValue(formData[f])}
              readOnly
              style={{ paddingLeft: getSymbolPadding(symbols[convertedCurrency]) }}
              className="w-full p-2.5 border border-gray-200 rounded-md text-sm bg-gray-50 text-gray-600"
            />
          </div>
        </div>
      ))}

      <div className="sm:col-span-2 text-xs text-gray-400 bg-gray-50 rounded-md p-3">
        <p>Live rates used for conversion.</p>
        <p className="mt-0.5">Rate: 1 {currency} = {(getConversionRate()).toFixed(4)} {convertedCurrency}</p>
      </div>

    </div>
  </div>
)}

        {section === 'Customer Info' && (
  <div className="col-span-1 sm:col-span-2 mt-2">
    <div className="flex items-center justify-between mb-3">
      <h4 className="text-sm font-medium text-gray-700">Travelling Members <span className="text-gray-400 font-normal">(Optional)</span></h4>
      <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
        <input
          type="checkbox"
          checked={isMembersNA}
          onChange={() => setIsMembersNA(!isMembersNA)}
          disabled={!isEditable}
          className="h-4 w-4 rounded border-gray-300"
        />
        <span className="text-gray-600">N/A</span>
      </label>
    </div>

    {!isMembersNA && (
      <>
        {members.map((m, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input
              type="text"
              value={m}
              onChange={(e) => updateMember(i, e.target.value)}
              className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
              readOnly={!isEditable}
              placeholder={`Member ${i + 1}`}
            />
            <button
              type="button"
              onClick={() => removeMember(i)}
              className="text-red-500 text-sm font-medium px-2 hover:text-red-700"
              disabled={!isEditable}
            >
              Remove
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addMember}
          className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
          disabled={!isEditable}
        >
          + Add Member
        </button>
      </>
    )}
    {isMembersNA && (
      <p className="text-gray-400 text-sm italic">Not Applicable</p>
    )}
  </div>
)}

              {section === 'Package Costing' && (
                <div className="col-span-1 sm:col-span-2 mt-2">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Extra Costs</h4>
                  {extraCosts.map((c, i) => (
                    <div key={i} className="flex flex-col sm:flex-row gap-2 mb-3">
                      <input
                        type="text"
                        value={c.label}
                        onChange={(e) => updateCostField(i, 'label', e.target.value)}
                        placeholder="Cost Label"
                        className="flex-1 p-2.5 border border-gray-300 rounded-md text-sm"
                        readOnly={!isEditable}
                      />
                      <div className="flex items-center gap-2">
                        <div className="relative flex-1 sm:flex-none">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">{symbols[currency]}</span>
                          <input
                            type="number"
                            value={c.value}
                            onChange={(e) => updateCostField(i, 'value', e.target.value)}
                            placeholder="Amount"
                            style={{ paddingLeft: getSymbolPadding(symbols[currency]) }}
                            className="w-full sm:w-32 p-2.5 border border-gray-300 rounded-md text-sm"
                            readOnly={!isEditable}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => removeCostField(i)}
                          className="text-red-500 text-sm font-medium whitespace-nowrap hover:text-red-700"
                          disabled={!isEditable}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={addCostField}
                    className="text-sm text-indigo-600 font-medium hover:text-indigo-800"
                    disabled={!isEditable}
                  >
                    + Add Cost Field
                  </button>
                </div>
              )}

              {section === 'Administrative' && (
                <div className="col-span-1 sm:col-span-2 mt-2">
                  <div className="flex flex-wrap gap-3 items-center">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className={`bg-green-500 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-green-600 transition-colors ${!isEditable ? 'opacity-60 cursor-not-allowed' : ''}`}
                      disabled={!isEditable}
                    >
                      Submit for Approval
                    </button>

                    {role !== 'employee' && location.state?.package?.status === 'approved' && (
                      <button
                        type="button"
                        onClick={() => {
                          const pkg = location.state.package;
                          const newData = { ...pkg.data };
                          delete newData['Invoice Reference'];
                          setReferenceId(null);
                          setFormData(newData);
                          setMembers(pkg.data?.['Travelling Members'] || []);
                          setExtraCosts(pkg.data?.['Extra Costs'] || []);
                          setIsEditable(true);
                          alert('New package created from approved one.');
                        }}
                        className="bg-indigo-600 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors"
                      >
                        Create New Package
                      </button>
                    )}
                  </div>

                  {!isEditable && (
                    <div className="text-sm text-red-600 mt-2">Package is approved and frozen.</div>
                  )}

                  <div className="mt-4 text-xs text-gray-500 bg-gray-50 rounded-md p-3">
                    <div>Rate: 1 {currency} = {getConversionRate(currency, convertedCurrency, rates).toFixed(4)} {convertedCurrency}</div>
                    <div className="mt-0.5 text-gray-400">{rates[currency] ? 'Live rates active' : 'Offline — using last known rates'}</div>
                    <div className="mt-1">Source: <a href="https://www.xe.com" target="_blank" rel="noreferrer" className="underline text-blue-600">XE.com</a></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
<div className="flex items-center gap-3 mt-6 mb-2 p-3 bg-indigo-50 rounded-lg">
  <span className="font-medium text-gray-700 text-sm">Show Converted Currency</span>
  <div
    onClick={() => setShowConverted(prev => !prev)}
    style={{
      width: 44, height: 24, borderRadius: 12, cursor: 'pointer', position: 'relative',
      backgroundColor: showConverted ? '#22c55e' : '#d1d5db',
      transition: 'background-color 0.3s'
    }}
  >
    <div style={{
      position: 'absolute', top: 3, left: showConverted ? 23 : 3,
      width: 18, height: 18, borderRadius: '50%', backgroundColor: '#fff',
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      transition: 'left 0.3s'
    }} />
  </div>
  <span className="text-xs text-gray-500">{showConverted ? 'ON' : 'OFF'}</span>
</div>

      </div>
    </div>
  );
};

export default PackageForm;